<template>
  <div class="container">
    <EditResumeSkeleton v-if="isPageLoading" />
    <template v-else>
      <router-link to="/userCenter" class="back-link">
        <img src="@/assets/images/arrow_left.svg" alt="Back" class="back_btn" />
      </router-link>
      <div class="resume_detail" :class="{ edit_resume_detail: open }">
        <div class="resume_title">
          Online Resume
        </div>
        <div class="score_wrapper">
          <div class="label">Current resume score: {{ nameState.score }}</div>
          <div class="score_tips">Improve these contents to increase the score</div>
          <div class="score_btn_wrapper">
            <span v-if="!advantageContent" class="score_btn" @click="handleOpenEditForm('advantage')">
              Personal advantages/strengths
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span v-if="!formNameState.headUrl" class="score_btn" @click="handleOpenEditForm('name')">
              Update photo
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span
              v-if="videoList.length == 0"
              class="score_btn"
              @click="
                handleOpenEditForm('video');
                initVideoModal('add');
              "
            >
              Skill video
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span v-if="workExperienceList.length == 0" class="score_btn" @click="handleInitWorkExperienceForm()">
              Work experience
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span v-if="evaluationList.length == 0" class="score_btn" @click="handleOpenEditForm('evaluation')">
              References
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span v-if="educationList.length == 0" class="score_btn" @click="handleInitEducationForm()">
              Education Experience
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span v-if="isShowMoreBtn" class="score_btn" @click="handleOpenEditForm('name')">
              More contact information
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span class="score_btn" @click="handleInitWorkExperienceForm()">
              Add more work experience
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
            <span
              class="score_btn"
              @click="
                handleOpenEditForm('video');
                initVideoModal('add');
              "
            >
              More skill videos
              <img src="@/assets/images/arrow_right_simple.svg" alt="" class="btn_icon" />
            </span>
          </div>
        </div>
        <div style="padding: 8px 23px;">
          <div class="info_wrapper">
            <div class="info">
              <div class="name">
                {{ nameState.displayName }}
                <img
                  src="@/assets/images/edit.svg"
                  alt="Edit Resume"
                  class="edit_icon"
                  @click="handleOpenEditForm('name')"
                />
              </div>
              <div v-if="nameState.jobStatus && nameState.city" class="type">
                {{ nameState.jobStatus }} <span style="margin: 0 10px;">|</span> {{ nameState.city }}
              </div>
              <div class="contact">
                <div class="email" v-if="nameState.email">
                  <img src="@/assets/images/email.svg" alt="" class="email_icon" />
                  {{ maskEmail(nameState.email) }}
                </div>
                <div class="phone" v-if="nameState.mobile">
                  <img src="@/assets/images/phone.svg" alt="" class="phone_icon" />
                  {{ maskMobile(nameState.mobile) }}
                </div>
                <div class="ins" v-if="nameState.link">
                  <img src="@/assets/images/ins.svg" alt="" class="phone_icon" />
                  have set
                </div>
              </div>
            </div>
            <img
              :src="nameState.headUrl"
              alt=""
              class="avatar"
              crossorigin="anonymous"
              @click="handleOpenEditForm('name')"
            />
          </div>
          <div class="tag_wrapper">
            <template v-for="item in positionList" :key="item.jobCategoryId">
              <div class="tag tag_positon">
                {{ item.jobCategoryName }}
              </div>
              <template v-for="data in item.jobSkills" :key="data.jobCategoryId">
                <div class="tag tag_skill">
                  {{ data.jobCategoryName }}
                </div>
              </template>
            </template>
            <img
              style="margin-top: 8px;"
              src="@/assets/images/edit.svg"
              alt="Edit Resume"
              class="edit_icon"
              @click="handleOpenEditForm('position')"
            />
          </div>
          <div v-if="videoList.length > 0" class="video_wrapper">
            <div class="title">
              <span>Skill videos</span>
              <img
                src="@/assets/images/edit.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                @click="handleOpenEditForm('video')"
              />
            </div>
            <div class="video_content">
              <div class="video" v-for="(item, index) in videoList" :key="index">
                <video
                  :poster="posterSrc(item)"
                  oncontextmenu="return false;"
                  :src="playSrc(item)"
                  :id="'videoPlayer' + index"
                  class="video_player"
                  muted
                  playsinline
                  preload="metadata"
                  @click.stop="handleInitVideoView(videoList, index)"
                  @loadedmetadata="getVideoDuration(index)"
                  @mouseenter="handleMouseEnter($event)"
                  @mouseleave="handleMouseLeave($event)"
                ></video>
                <span v-show="videoDurationList[index]" class="video_duration">
                  {{ formatToMinutes(videoDurationList[index]) }}
                </span>
                <p class="video_title">{{ item.jobCategoryName }}</p>
              </div>
            </div>
          </div>
          <div v-if="advantageContent" class="advantage_wrapper">
            <div class="title">
              <span>Personal strengths</span>
              <img
                src="@/assets/images/edit.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                @click="handleOpenEditForm('advantage')"
              />
            </div>
            <div class="description">
              {{ advantageContent }}
            </div>
          </div>
          <div v-if="workExperienceList.length > 0" class="work_wrapper">
            <div class="title">
              <span>Work experience</span>
              <img
                src="@/assets/images/add_circle.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                v-if="workExperienceList.length > 0"
                @click="handleInitWorkExperienceForm()"
              />
            </div>
            <div class="description">
              <div class="experience_wrapper" v-for="(item, index) in workExperienceList" :key="index">
                <div class="experience">
                  <div class="left_info">
                    <div class="company">{{ item.companyName }}</div>
                    <div class="position">{{ item.position }}</div>
                  </div>
                  <div class="right_info">
                    <div class="time">
                      {{ formatDate(item.startDate) + ' - ' + (item.endDate ? formatDate(item.endDate) : 'Present') }}
                    </div>
                    <img
                      src="@/assets/images/edit.svg"
                      alt="Edit Resume"
                      class="edit_icon"
                      @click="handleInitWorkExperienceForm(item)"
                    />
                  </div>
                </div>
                <div class="content">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="educationList.length > 0" class="education_wrapper">
            <div class="title">
              <span>Education Experience</span>
              <img
                src="@/assets/images/add_circle.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                v-if="educationList.length > 0"
                @click="handleInitEducationForm()"
              />
            </div>
            <div class="description">
              <div class="experience_wrapper" v-for="(item, index) in educationList" :key="index">
                <div class="experience">
                  <img :src="item.logoPngPath" alt="" class="school_icon" @error="hideInvalidImage" />
                  <div class="info">
                    <div class="school_row">
                      <span class="school">{{ item.school }}</span>
                      <div class="right_info">
                        <span class="time"
                          >{{ item.startDate.slice(0, 4) }} -
                          {{ item.endDate ? item.endDate.slice(0, 4) : 'Present' }}</span
                        >
                        <img
                          src="@/assets/images/edit.svg"
                          alt="Edit Resume"
                          class="edit_icon"
                          @click="handleInitEducationForm(item)"
                        />
                      </div>
                    </div>
                    <div>
                      <span class="degree">{{ item.degree }}</span>
                      <span class="major">{{ item.major }}</span>
                    </div>
                  </div>
                </div>
                <div class="content">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="certState.description || certState.imageUrls.length > 0" class="cert_wrapper">
            <div class="title">
              <span>Certificate</span>
              <img
                src="@/assets/images/edit.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                @click="handleOpenEditForm('certificate')"
              />
            </div>
            <div class="description">
              {{ certState.description }}
            </div>
            <div class="cert_content">
              <div
                class="cert"
                v-for="(item, index) in certState.imageUrls"
                :key="index"
                @click="handleInitImageView(item)"
              >
                <img :src="item" class="cert_preview" />
              </div>
            </div>
          </div>
          <div v-if="evaluationList.length > 0" class="evaluation_wrapper">
            <div class="title">
              <span>References</span>
              <img
                src="@/assets/images/edit.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                @click="handleOpenEditForm('evaluation')"
              />
            </div>
            <div
              class="evaluation"
              v-for="(item, index) in evaluationList.filter((item) => item.isHidden === 0)"
              :key="index"
            >
              <div class="label">
                <span class="name">{{ item.evaluatorName }}</span>
                <span class="relation">{{ item.evaluatorRelation }}</span>
              </div>
              <div class="content">
                {{ item.textContent }}
                <div class="file_wrapper">
                  <img v-if="item.imageUrls" :src="item.imageUrls" class="img_preview" />
                  <video
                    v-if="item.videoUrl"
                    :poster="posterSrc(item)"
                    oncontextmenu="return false;"
                    :src="playSrc(item)"
                    class="video_player"
                    muted
                    @click.stop="handleInitVideoView([{ videoUrl: item.videoUrl, playUrl: item.playUrl, coverUrl: item.coverUrl }], 0)"
                    @mouseenter="handleMouseEnter($event)"
                    @mouseleave="handleMouseLeave($event)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="influenceContent" class="influence_wrapper">
            <div class="title">
              <span>What am I working on?</span>
              <img
                src="@/assets/images/edit.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                @click="handleOpenEditForm('influence')"
              />
            </div>
            <div class="description">
              {{ influenceContent }}
            </div>
          </div>
          <div v-if="currentTask" class="influence_wrapper">
            <div class="title">
              <span>How can the workplace support me to perform better?</span>
              <img
                src="@/assets/images/edit.svg"
                alt="Edit Resume"
                class="edit_icon edit_icon_right"
                @click="handleOpenEditForm('currentTask')"
              />
            </div>
            <div class="description">
              {{ currentTask }}
            </div>
          </div>
          <div class="resume_action_wrapper">
            <a-tooltip placement="leftTop">
              <template #title>
                <span>Check the effect of the resume displayed on different pages after it is completed.</span>
              </template>
              <div class="item" @click="handleOpenPreviewModal()">
                <img src="@/assets/images/preview.svg" alt="" class="icon" />
                <p class="label">Preview</p>
              </div>
            </a-tooltip>
            <a-tooltip placement="leftTop">
              <template #title>
                <span>Ask your teachers, parents, or friends to help you complete your resume.</span>
              </template>
              <div v-if="!isHelpEditResume" class="item" @click="helpVisible = true">
                <img src="@/assets/images/for_help.svg" alt="" class="icon" />
                <p class="label">Help</p>
              </div>
            </a-tooltip>
          </div>
          <div
            v-if="videoList.length == 0"
            class="add_video"
            @click="
              handleOpenEditForm('video');
              initVideoModal('add');
            "
          >
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            <div class="text">Skill video</div>
          </div>
          <div v-if="!advantageContent" class="add_wrapper" @click="handleOpenEditForm('advantage')">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            Personal advantages/strengths
          </div>
          <div v-if="workExperienceList.length == 0" class="add_wrapper" @click="handleInitWorkExperienceForm()">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            Work Experience
          </div>
          <div v-if="educationList.length == 0" class="add_wrapper" @click="handleInitEducationForm()">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            Education Experience
          </div>
          <div
            v-if="!(certState.description || certState.imageUrls.length > 0)"
            class="add_wrapper"
            @click="handleOpenEditForm('certificate')"
          >
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            Certificate
          </div>
          <div v-if="evaluationList.length == 0" class="add_wrapper" @click="handleOpenEditForm('evaluation')">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            References
          </div>
          <div v-if="!influenceContent" class="add_wrapper" @click="handleOpenEditForm('influence')">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            What am I working on?
          </div>
          <div v-if="!currentTask" class="add_wrapper" @click="handleOpenEditForm('currentTask')">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            How can the workplace support me to perform better?
          </div>
        </div>
      </div>
      <a-drawer
        rootClassName="resume_drawer"
        :open="open"
        :body-style="{ paddingBottom: '80px' }"
        :footer-style="{ textAlign: 'right' }"
        @close="handleCloseDrawer"
      >
        <a-form
          v-if="editType == 'name'"
          class="resume_form"
          ref="formNameRef"
          :model="formNameState"
          layout="vertical"
        >
          <div class="title">Primary Profile</div>
          <div class="avatar_wrapper">
            <div class="avatar" @click="handleUploadClick">
              <img :src="formNameState.headUrl" alt="" @error="setDefaultAvatarImage" />
              <div v-if="!isLoading" class="mask">
                <img src="@/assets/images/upload_resume.svg" alt="Edit Resume" class="upload_icon" />
              </div>
              <a-spin class="avatar_loading" :spinning="isLoading" :indicator="indicator" />
            </div>
            <div class="update" @click="handleUploadClick">Update photo</div>
            <input type="file" ref="jdInput" style="display:none" @change="handleFileChange" />
          </div>
          <div class="flex_box">
            <div class="label">Name</div>
            <a-form-item
              validateTrigger="submit"
              label=""
              name="firstName"
              :rules="[{ required: true, message: 'Enter First Name' }]"
            >
              <a-input
                autocomplete="off"
                v-model:value="formNameState.firstName"
                placeholder="First Name"
                :maxlength="80"
              />
            </a-form-item>
            <a-form-item
              validateTrigger="submit"
              label=""
              name="lastName"
              :rules="[{ required: true, message: 'Enter Last Name' }]"
            >
              <a-input
                autocomplete="off"
                v-model:value="formNameState.lastName"
                placeholder="Last Name"
                :maxlength="80"
              />
            </a-form-item>
          </div>
          <div class="flex_box">
            <a-form-item
              validateTrigger="blur"
              label=""
              name="nickName"
              :rules="[{ required: formNameState.useNicknameInResume, message: 'Enter nickName' }]"
            >
              <a-input v-model:value="formNameState.nickName" placeholder="Nick Name" :maxlength="20" />
            </a-form-item>
            <a-form-item class="switch_item" validateTrigger="blur" label="">
              <a-switch v-model:checked="formNameState.useNicknameInResume" />
              <span class="switch_tips">Using a nickname in a resume</span>
            </a-form-item>
          </div>
          <a-form-item validateTrigger="submit" label="Type of work seeking" name="jobStatus">
            <a-select
              class="resume_select"
              v-model:value="formNameState.jobStatus"
              size="large"
              :popupClassName="'resume_select_dropdown'"
              :rules="[{ required: true, message: 'Enter jobStatus' }]"
            >
              <a-select-option v-for="item in JOB_STATUS_OPTIONS" :key="item" :value="item">{{ item }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            validateTrigger="submit"
            label="Expected Address"
            name="city"
            :rules="[{ required: true, message: 'Enter Expected Address' }]"
          >
            <CityInputItem
              @on-change="handleChangeCity"
              class="resume_select"
              :isShowAll="false"
              :selectedCity="formNameState.city"
            />
          </a-form-item>
          <a-form-item
            validateTrigger="submit"
            name="email"
            :rules="[{ type: 'email', message: 'Please enter a valid email address' }]"
          >
            <template #label>
              <div
                style="display: inline-flex;
    align-items: flex-start;"
              >
                <span class="label">Email</span>
                <span class="tips" style="white-space: pre-wrap;"
                  >Please use your guardian's email if it applies to your situation.(Only verified enterprises can
                  access the email address)</span
                >
              </div>
            </template>
            <a-input
              @click="handleInitChangeEmailModel"
              autocomplete="off"
              v-model:value="formNameState.email"
              placeholder="Enter your email"
              :maxlength="80"
              readonly
              style="cursor: pointer;"
            />
          </a-form-item>
          <a-form-item validateTrigger="submit" name="mobile">
            <template #label>
              <span class="label">Phone Number</span>
              <span class="tips">Only verified enterprises can view the mobile phone number</span>
            </template>
            <a-input
              autocomplete="off"
              v-model:value="formNameState.mobile"
              placeholder="Phone Number"
              :maxlength="80"
            />
          </a-form-item>
          <a-form-item
            validateTrigger="submit"
            label="Instagram"
            name="link"
            :rules="[{ validator: validateInstagramURL }]"
          >
            <a-input autocomplete="off" v-model:value="formNameState.link" placeholder="Instagram" :maxlength="50" />
          </a-form-item>
        </a-form>
        <a-form v-else-if="editType == 'position'" class="resume_form" layout="vertical">
          <div class="title">Desired Position</div>
          <div v-if="formPositionList.length < 3" class="add_position" @click="handlePositionModalOpen()">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            Add a desired position
          </div>
          <div class="job_position" v-for="(item, index) in formPositionList" :key="index">
            <div class="label">
              <span>Job title{{ index + 1 }}</span>
              <div class="action_wrapper">
                <img
                  v-if="formPositionList.length > 1"
                  src="@/assets/images/delete.svg"
                  class="action_icon"
                  @click="handleDeletePositionItem(item.jobCategoryId)"
                />
                <img
                  v-if="index != formPositionList.length - 1"
                  src="@/assets/images/arrow_down.svg"
                  class="action_icon"
                  @click="handleSortPositionItem('down', item)"
                />
                <img
                  v-if="index != 0"
                  src="@/assets/images/arrow_up.svg"
                  class="action_icon"
                  @click="handleSortPositionItem('up', item)"
                />
              </div>
            </div>
            <div class="position" @click="handlePositionModalOpen('edit', item, index)">
              <span>{{ item.jobCategoryName }}</span>
              <div class="skill_wrapper">
                <span class="skill_item" v-for="(data, indexS) in item.jobSkills" :key="indexS">{{
                  data.jobCategoryName
                }}</span>
              </div>
              <img src="@/assets/images/arrow_right_simple.svg" class="update_icon" />
            </div>
          </div>
          <PositionModal
            ref="PositionModalRef"
            :isEdit="isEditPositionModal"
            @select-item="handleSelectPositionItem"
            @modify-item="handleModifyPositionItem"
          />
        </a-form>
        <a-form v-else-if="editType == 'video'" class="resume_form" layout="vertical">
          <div class="title">Skill videos</div>
          <div class="description">Uploading skill videos can increase the exposure of your resume</div>
          <div class="video_action_wrapper" @click="initVideoModal('add')">
            <span class="add_btn"><img src="@/assets/images/add_circle.svg" />Add</span>
          </div>
          <TransitionGroup name="video" tag="div" class="video_content" @mouseleave="sortMaskSuppressed = false">
            <div
              class="video"
              v-for="(item, index) in formVideoList"
              :key="getVideoKey(item)"
              :class="{ sort_clicked: sortMaskSuppressed, action_open: activeVideoActionKey === getVideoKey(item) }"
            >
              <div class="mask" style="height: 307px;"></div>
              <img
                :src="item.posterUrl || defaultVideoCover"
                oncontextmenu="return false;"
                class="video_player"
                style="height: 307px;"
              />
              <p class="video_title">{{ item.jobCategoryName }}</p>
              <div class="video_more_btn" @click.stop="toggleVideoAction(item)">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="video_content_action_wrapper" @click="activeVideoActionKey = ''">
                <div class="video_content_action">
                  <img
                    class="action_icon"
                    :class="{ action_disabled: index == 0 }"
                    src="@/assets/images/video_action/arrow_first.svg"
                    @click="handleFirstVideoItem(item)"
                  />
                  <img
                    class="action_icon"
                    :class="{ action_disabled: index == formVideoList.length - 1 }"
                    src="@/assets/images/video_action/arrow_last.svg"
                    @click="handleLastVideoItem(item)"
                  />
                </div>
                <div class="video_content_action">
                  <img
                    class="action_icon"
                    :class="{ action_disabled: index == 0 }"
                    src="@/assets/images/video_action/arrow_left.svg"
                    @click="handleUpVideoItem(item)"
                  />
                  <img
                    class="action_icon"
                    :class="{ action_disabled: index == formVideoList.length - 1 }"
                    src="@/assets/images/video_action/arrow_right.svg"
                    @click="handleDownVideoItem(item)"
                  />
                </div>
                <div class="video_content_action">
                  <img
                    class="action_icon"
                    src="@/assets/images/video_action/delete.svg"
                    @click="handleDeleteVideoItem(item)"
                  />
                  <img
                    class="action_icon"
                    src="@/assets/images/video_action/view.svg"
                    @click="handleViewVideoItem(item)"
                  />
                </div>
                <div class="video_content_action">
                  <img
                    class="action_icon"
                    src="@/assets/images/video_action/edit.svg"
                    @click="initVideoModal('edit', item)"
                  />
                </div>
              </div>
            </div>
          </TransitionGroup>
        </a-form>
        <a-form v-else-if="editType == 'advantage'" class="resume_form" layout="vertical">
          <div class="title">Personal strengths</div>
          <div class="description">
            Personal strengths will be showcased on the homepage, craft a personalized statement to help you standout.
          </div>
          <div class="ai_textarea_wrapper">
            <a-textarea
              name="search"
              placeholder="Please enter"
              :auto-size="{ minRows: 10 }"
              :maxlength="800"
              :showCount="true"
              class="resume_textarea"
              v-model:value="advantageContentState"
            />
            <button type="button" class="ai_btn" @click="handleInitSkillModal" :disabled="isSubmitDisabled">
              <img src="@/assets/images/ai_resume_white.svg" alt="" class="icon" />
              <span>AI polishing</span>
            </button>
          </div>
        </a-form>
        <a-form
          v-else-if="editType == 'work'"
          ref="formWorkRef"
          class="resume_form"
          :model="formWorkState"
          layout="vertical"
        >
          <div class="title" style="margin-bottom:20px;">Work experience</div>
          <a-form-item
            validateTrigger="submit"
            label="Company Name"
            name="companyName"
            :rules="[{ required: true, message: 'Enter Company Name' }]"
          >
            <a-input
              v-model:value="formWorkState.companyName"
              placeholder="Company name"
              autocomplete="off"
              :maxlength="80"
              @input="onBusinessInput($event)"
            />
            <ul
              v-if="showBusinessSuggestions"
              class="suggestions_list business_suggestions"
              ref="businessSuggestionsRef"
            >
              <li v-for="item in businessList.slice(0, 10)" :key="item.value" @click="selectBusinessSuggestion(item)">
                <span class="business_name">{{ item.value }}</span>
              </li>
            </ul>
          </a-form-item>
          <div class="flex_box">
            <div class="label">Employment Period</div>
            <a-form-item
              validateTrigger="submit"
              name="startDate"
              :rules="[{ required: true, message: 'Enter Start Date' }]"
            >
              <a-date-picker
                class="custom_datepicker"
                popupClassName="custom_datepicker_popup"
                v-model:value="formWorkState.startDate"
                picker="month"
                :disabledDate="disabledStartDate"
                valueFormat="YYYY-MM"
              />
            </a-form-item>
            <a-form-item validateTrigger="submit" name="endDate">
              <a-date-picker
                class="custom_datepicker"
                popupClassName="custom_datepicker_popup"
                v-model:value="formWorkState.endDate"
                picker="month"
                :disabledDate="disabledEndDate"
                valueFormat="YYYY-MM"
                :placeholder="formWorkState.endDate ? '' : 'Present'"
              />
            </a-form-item>
          </div>
          <a-form-item
            validateTrigger="submit"
            label="Job Title"
            name="position"
            :rules="[{ required: true, message: 'Enter Job Title' }]"
          >
            <a-input
              autocomplete="off"
              v-model:value="formWorkState.position"
              placeholder="Job Title"
              :maxlength="80"
              @input="onInput($event)"
            />
            <ul v-if="showSuggestions" class="suggestions_list" ref="suggestionsRef">
              <li v-for="item in suggestions.slice(0, 10)" :key="item.job" @click="selectSuggestion(item)">
                <span class="skill">{{ item.job }}</span>
                <span class="position">{{ item.industry }}</span>
              </li>
            </ul>
          </a-form-item>
          <div class="ai_textarea_wrapper">
            <div class="label">Responsibilities and Achievements</div>
            <a-form-item
              validateTrigger="submit"
              name="description"
              :rules="[{ required: true, message: 'Enter Job Title' }]"
            >
              <a-textarea
                name="search"
                placeholder="You can enter:
1.Main responsibilities
2.Achievements"
                :auto-size="{ minRows: 10 }"
                :maxlength="800"
                :showCount="true"
                class="resume_textarea"
                v-model:value="formWorkState.description"
              />
              <button type="button" class="ai_btn" @click="handleSubmitAIPolishing" :disabled="isSubmitDisabled">
                <img src="@/assets/images/ai_resume_white.svg" alt="" class="icon" />
                <span>AI polishing</span>
              </button>
            </a-form-item>
          </div>
        </a-form>
        <a-form
          v-else-if="editType == 'education'"
          class="resume_form"
          ref="formEducationRef"
          :model="formEducationState"
          layout="vertical"
        >
          <div class="title" style="margin-bottom:20px;">Education Experience</div>
          <a-form-item
            validateTrigger="submit"
            label="School Name"
            name="school"
            :rules="[{ required: true, message: 'Enter School Name' }]"
          >
            <a-input
              v-model:value="formEducationState.school"
              placeholder="School name"
              autocomplete="off"
              :maxlength="80"
              @input="onSchoolInput($event)"
            />
            <ul v-if="showSchoolSuggestions" class="suggestions_list school_suggestions" ref="schoolSuggestionsRef">
              <li v-for="item in schoolList.slice(0, 10)" :key="item.value" @click="selectSchoolSuggestion(item)">
                <span class="school_name">{{ item.value }}</span>
              </li>
            </ul>
          </a-form-item>
          <div class="flex_box">
            <div class="label">Dates</div>
            <a-form-item
              validateTrigger="submit"
              name="startDate"
              :rules="[{ required: true, message: 'Enter Dates' }]"
            >
              <a-range-picker
                class="custom_datepicker"
                popupClassName="custom_datepicker_popup"
                v-model:value="datesRange"
                :disabled-date="disabledDate"
                picker="year"
                valueFormat="YYYY-MM-DD"
                @change="handleDatesRangeChange"
              />
            </a-form-item>
          </div>
          <a-form-item
            validateTrigger="submit"
            label="Education Level"
            name="degree"
            :rules="[{ required: true, message: 'Enter Education Level' }]"
          >
            <a-input
              autocomplete="off"
              v-model:value="formEducationState.degree"
              placeholder="Education Level"
              :maxlength="80"
            />
          </a-form-item>
          <a-form-item validateTrigger="submit" label="Major" name="major">
            <a-input autocomplete="off" v-model:value="formEducationState.major" placeholder="Major" :maxlength="80" />
          </a-form-item>
          <div class="ai_textarea_wrapper">
            <div class="label">School experience</div>
            <a-textarea
              name="search"
              placeholder="Please enter"
              :auto-size="{ minRows: 10 }"
              :maxlength="800"
              :showCount="true"
              class="resume_textarea"
              v-model:value="formEducationState.description"
            />
            <button type="button" class="ai_btn" @click="handleSubmitAIPolishing" :disabled="isSubmitDisabled">
              <img src="@/assets/images/ai_resume_white.svg" alt="" class="icon" />
              <span>AI polishing</span>
            </button>
          </div>
        </a-form>
        <a-form v-else-if="editType == 'evaluation'" class="resume_form" layout="vertical">
          <div class="title">Feedback received</div>
          <div class="add_position" style="text-align:center;" @click="evaluationVisible = true">
            <img src="@/assets/images/add.svg" alt="" class="add_icon" />
          </div>
          <div class="evaluation_list_wrapper">
            <div class="evaluation_item" v-for="(item, index) in evaluationActiveList" :key="index">
              <span
                >Send an evaluation invitation to <span class="evaluation_email">{{ item.inviteeEmail }}</span></span
              >
              <span class="cancel_btn" @click="initDeleteEvaluationActiveItem(item.invitationId)">Cancel</span>
            </div>
          </div>
          <div class="evaluation_tabs_wrapper" v-for="(item, index) in formEvaluationList" :key="index">
            <div class="action_wrapper">
              <img
                src="@/assets/images/delete.svg"
                class="action_icon"
                @click="initDeleteEvaluationItem(item.evaluationId)"
              />
              <img
                v-if="index != 0"
                src="@/assets/images/arrow_up.svg"
                class="action_icon"
                @click="handleUpEvaluationItem(item.evaluationId)"
              />
              <img
                v-if="index != formEvaluationList.length - 1"
                src="@/assets/images/arrow_down.svg"
                @click="handleDownEvaluationItem(item.evaluationId)"
                class="action_icon"
              />
              <a-tooltip placement="topLeft">
                <template #title>
                  <span>{{ item.isHidden == '0' ? 'Hide this review' : 'Show this review' }}</span>
                </template>
                <a-switch class="action_switch" v-model:checked="item.isHidden" :checkedValue="0" :unCheckedValue="1" />
              </a-tooltip>
            </div>
            <div class="evaluation">
              <div class="label">
                <span class="name">{{ item.evaluatorName }}</span>
                <span class="relation">{{ item.evaluatorRelation }}</span>
              </div>
              <div class="content">
                {{ item.textContent }}
                <div class="file_wrapper">
                  <img v-if="item.imageUrls" :src="item.imageUrls" class="img_preview" />
                  <video
                    v-if="item.videoUrl"
                    :poster="posterSrc(item)"
                    controls
                    controlslist="nodownload"
                    oncontextmenu="return false;"
                    :src="playSrc(item)"
                    class="video_player"
                  />
                </div>
              </div>
            </div>
          </div>
        </a-form>
        <a-form v-else-if="editType == 'certificate'" class="resume_form" layout="vertical">
          <div class="title">Certificate</div>
          <div class="ai_textarea_wrapper">
            <a-textarea
              name="search"
              placeholder="Please enter the information related to the certificate"
              :auto-size="{ minRows: 6 }"
              :maxlength="800"
              :showCount="true"
              class="resume_textarea"
              v-model:value="formCertState.description"
            />
          </div>
          <div class="title" style="font-size:14px;font-weight:normal;margin-bottom:16px;">
            Upload the certificate photo
          </div>
          <div class="cert_content">
            <div class="cert" v-for="(item, index) in formCertState.imageUrls" :key="index">
              <div class="mask"></div>
              <img
                :src="item"
                class="cert_preview"
                :class="{ cert_preview_landscape: isLandscape(item), cert_preview_portrait: !isLandscape(item) }"
              />
              <div class="cert_content_action_wrapper">
                <div class="cert_content_action">
                  <img
                    class="action_icon"
                    src="@/assets/images/video_action/view.svg"
                    @click="handleInitImageView(item)"
                  />
                  <img
                    class="action_icon"
                    src="@/assets/images/video_action/delete.svg"
                    @click="handleDeleteCertItem(index)"
                  />
                  <img
                    class="action_icon"
                    src="@/assets/images/video_action/refresh.svg"
                    @click="initCertModal('edit', item, index)"
                  />
                </div>
              </div>
            </div>
            <div class="cert add_cert" @click="initCertModal('add')">
              <img src="@/assets/images/add.svg" alt="" class="add_icon" />
            </div>
          </div>
        </a-form>
        <a-form v-else-if="editType == 'influence'" class="resume_form" layout="vertical">
          <div class="title">What am I working on?</div>
          <div class="ai_textarea_wrapper">
            <a-textarea
              name="search"
              placeholder="Please enter"
              :auto-size="{ minRows: 10 }"
              :maxlength="800"
              :showCount="true"
              class="resume_textarea"
              v-model:value="influenceContentState"
            />
          </div>
        </a-form>
        <a-form v-else-if="editType == 'currentTask'" class="resume_form" layout="vertical">
          <div class="title">How can the workplace support me to perform better?</div>
          <div class="ai_textarea_wrapper">
            <a-textarea
              name="search"
              placeholder="Please enter"
              :auto-size="{ minRows: 10 }"
              :maxlength="800"
              :showCount="true"
              class="resume_textarea"
              v-model:value="currentTaskState"
            />
          </div>
        </a-form>
        <template #extra>
          <a-space>
            <img
              v-if="formWorkState.resumeExperienceId && editType == 'work'"
              class="delete_icon"
              src="@/assets/images/delete.svg"
              @click="initDeleteWorkExperience"
            />
            <img
              v-if="formEducationState.resumeEducationId && editType == 'education'"
              class="delete_icon"
              src="@/assets/images/delete.svg"
              @click="initDeleteEducation"
            />
            <a-button class="confirm_btn" type="primary" @click.stop="handleSubmitEditForm">Publish</a-button>
          </a-space>
        </template>
      </a-drawer>
      <!-- upload video modal -->
      <a-modal
        class="resume_modal"
        v-model:open="videoVisible"
        title="Upload a video"
        @cancel="videoVisible = false"
        :footer="null"
      >
        <a-form class="resume_form" ref="formVideoRef" :model="formViedoState" layout="vertical">
          <a-form-item
            validateTrigger="blur"
            name="jobCategoryName"
            :rules="[{ required: true, message: 'Select Skills' }]"
          >
            <a-input
              autocomplete="off"
              v-model:value="formViedoState.jobCategoryName"
              placeholder="Select Skills"
              :maxlength="80"
              @input="onInput($event)"
            />
            <ul v-if="showSuggestions" class="suggestions_list">
              <li v-for="item in suggestions.slice(0, 10)" :key="item.job" @click="selectSuggestion(item)">
                <span class="skill">{{ item.job }}</span>
                <span class="position">{{ item.industry }}</span>
              </li>
            </ul>
          </a-form-item>
          <Upload
            ref="uploadRef"
            accept="video/*"
            @on-upload="handleOnUploaded"
            @on-upload-with-cover="handleOnUploadedWithCover"
          />
          <div class="note">
            <p><span class="dot"></span>Both landscape and portrait videos can be uploaded directly</p>
            <p><span class="dot"></span>We recommend uploading videos no longer than 5 minutes</p>
          </div>
          <a-button
            type="primary"
            html-type="button"
            class="submit_btn"
            @click.prevent="doSubmitVideoChange"
            :disabled="isSubmitDisabled"
          >
            Done
          </a-button>
        </a-form>
      </a-modal>
      <!-- upload cert modal -->
      <a-modal
        class="resume_modal"
        v-model:open="certVisible"
        title="Upload a certificate photo"
        @cancel="certVisible = false"
        :footer="null"
      >
        <a-form class="resume_form" ref="formCertRef" :model="formCertState" layout="vertical">
          <Upload ref="uploadCertRef" accept="image/*" @on-upload="handleOnCertUploaded" class="upload_cert" />
          <a-button
            type="primary"
            html-type="button"
            class="submit_btn"
            @click.prevent="doSubmitCertChange"
            :disabled="isSubmitDisabled"
          >
            Done
          </a-button>
        </a-form>
      </a-modal>
      <a-modal class="resume_modal" v-model:open="skillVisible" @cancel="skillVisible = false" :footer="null">
        <template #title>
          <img src="@/assets/images/ai_resume.svg" alt="Skill Icon" class="skill_icon" />
          Select personal qualities
        </template>
        <div class="skill_container">
          <div class="select_count">Multi-select({{ selectedSkillList.length }})</div>
          <div class="skill_wrapper">
            <span
              class="skill"
              :class="{ selected: selectedSkillList.some((skill) => skill === item) }"
              v-for="item in skillList"
              :key="item.categoryId"
              @click="handleClickSkillItem(item)"
            >
              {{ item }}
            </span>
          </div>
          <div class="btn_wrapper">
            <a-button class="cancel_btn" @click="skillVisible = false">Cancel</a-button>
            <a-button
              class="confirm_btn"
              type="primary"
              @click.prevent="handleSubmitAIPolishing"
              :disabled="isSubmitDisabled"
            >
              Done
            </a-button>
          </div>
        </div>
      </a-modal>
      <!-- evaluation modal -->
      <a-modal
        class="resume_modal evaluation_modal"
        v-model:open="evaluationVisible"
        @cancel="
          evaluationVisible = false;
          evaluationStep = 1;
        "
        :footer="null"
      >
        <template v-if="evaluationStep == 1" #title>
          Send review invitations to others
        </template>
        <template v-else-if="evaluationStep == 2" #title>
          Send email
        </template>
        <div v-if="evaluationStep == 1">
          <div class="tips">Completed evaluations will appear on your resume</div>
          <div class="section_wrapper">
            <div class="section" @click="handleEvaluationSection('email')">
              <img class="label_icon" src="@/assets/images/help_email.png" />
              <span>Send an email invitation</span>
              <RightOutlined class="arrow_icon" />
            </div>
            <div class="section" @click="handleEvaluationSection('link')">
              <img class="label_icon" src="@/assets/images/help_link.svg" />
              <span>Copy the invitation link</span>
              <RightOutlined class="arrow_icon" />
            </div>
          </div>
        </div>
        <div v-else-if="evaluationStep == 2">
          <a-form
            class="resume_form"
            ref="formEvaluationRef"
            :model="formEvaluationState"
            layout="vertical"
            style="margin: 30px auto;"
          >
            <EmailInputItem @change-email="handleChangeEmail" />
          </a-form>
          <a-button
            class="submit_btn"
            type="primary"
            @click="handleSubmitEmailEvaluation"
            :disabled="isSubmitDisabled"
            :loading="isSendingEvaluation"
          >
            Send
            <img v-if="!isSendingEvaluation" class="btn_icon" src="@/assets/images/airplane.svg" />
          </a-button>
        </div>
      </a-modal>
      <!-- help modal -->
      <a-modal
        class="resume_modal evaluation_modal"
        v-model:open="helpVisible"
        @cancel="
          helpVisible = false;
          helpStep = 1;
        "
        :footer="null"
      >
        <template v-if="helpStep == 1" #title>
          Help
        </template>
        <template v-else-if="helpStep == 2" #title>
          Send email
        </template>
        <div v-if="helpStep == 1">
          <div class="section_wrapper">
            <div class="section" @click="handleHelpSection('email')">
              <div>
                <img class="label_icon" src="@/assets/images/help_email.png" />
                <span>Send an email to invite someone for help</span>
              </div>
              <div class="label_description">
                Fill in his/her email address, and JoyJobs will send an email invitation to the other party to help you
                complete your resume.
              </div>
              <RightOutlined class="arrow_icon" />
            </div>
            <div class="section" @click="handleHelpSection('link')">
              <div>
                <img class="label_icon" src="@/assets/images/help_link.svg" />
                <span>Copy Resume Editing Link</span>
              </div>
              <div class="label_description">
                Copy the link and send it to the person who will help you fill it out
              </div>
              <RightOutlined class="arrow_icon" />
            </div>
            <div class="tips_wrapper">
              <img src="@/assets/images/tips_tag.svg" alt="" class="icon" />
              The invitation to request help will be valid for 7 days. If the recipient does not have enough time to
              edit, it will be necessary to resend the help invitation.
            </div>
          </div>
        </div>
        <div v-else-if="helpStep == 2">
          <a-form
            class="resume_form"
            ref="formHelpRef"
            :model="formHelpState"
            layout="vertical"
            style="margin: 30px auto;"
          >
            <EmailInputItem @change-email="handleChangeEmail" />
          </a-form>
          <a-button
            class="submit_btn"
            type="primary"
            @click="handleSubmitEmailHelp"
            :disabled="isSubmitDisabled"
            :loading="isSendingHelp"
          >
            Send
            <img v-if="!isSendingHelp" class="btn_icon" src="@/assets/images/airplane.svg" />
          </a-button>
        </div>
      </a-modal>
      <!-- resume preview modal -->
      <a-modal
        class="resume_modal resume_preview_modal"
        v-model:open="resumeModalvisible"
        title=""
        @cancel="resumeModalvisible = false"
        width="1100px"
        :footer="null"
      >
        <ResumePreview ref="ResumePreviewRef" :resumeToken="resumePreviewToken" :isShowCard="true" />
      </a-modal>
      <!-- resume complete modal -->
      <a-modal
        class="resume_modal"
        v-model:open="completeVisible"
        @cancel="completeVisible = false"
        :closable="false"
        :maskClosable="false"
        :footer="null"
      >
        <template #title>Please provide the following information</template>
        <a-form class="modal_form" ref="formCompleteRef" :model="formCompleteState">
          <a-form-item
            v-if="!completeState.jobStatus"
            validateTrigger="blur"
            label=""
            name="jobStatus"
            :rules="[{ required: true, message: 'Please select the type of work first' }]"
          >
            <div class="form_label">What type of work are you seeking?</div>
            <a-select
              class="resume_select resume_complete_select"
              v-model:value="formCompleteState.jobStatus"
              size="large"
              :popupClassName="'resume_select_dropdown'"
              :rules="[{ required: true, message: 'Enter jobStatus' }]"
            >
              <a-select-option v-for="item in JOB_STATUS_OPTIONS" :key="item" :value="item">{{ item }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            v-if="!completeState.city"
            validateTrigger="blur"
            label=""
            name="city"
            :rules="[{ required: true, message: 'Enter City' }]"
          >
            <div class="form_label">Preferred job location</div>
            <CityInputItem
              @on-change="handleChangeCompleteCity"
              class="resume_select resume_complete_select"
              :isShowAll="false"
            />
          </a-form-item>
          <a-form-item
            v-if="completeState.jobSkills.length == 0"
            validateTrigger="blur"
            label=""
            name="jobSkills"
            :rules="[{ required: true, message: 'Select Your Desired Position' }]"
          >
            <div class="form_label">Job expectations</div>
            <div class="resume_position_wrapper" @click="handleOpenPositionModal">
              <span :style="{ opacity: formCompleteState.jobSkills.length > 0 ? 1 : 0.5 }">{{
                formCompleteState.jobSkills.length > 0
                  ? formCompleteState.jobSkills[0].jobCategoryName
                  : 'Desired Position'
              }}</span>
              <div class="skill_wrapper" v-if="formCompleteState.jobSkills[0]">
                <span
                  class="skill_item"
                  v-for="(data, indexS) in formCompleteState.jobSkills[0].jobSkills"
                  :key="indexS"
                  >{{ data.jobCategoryName }}</span
                >
              </div>
              <DownOutlined class="arrow_icon" />
            </div>
          </a-form-item>
          <div class="btn_wrapper">
            <button type="button" class="submit_btn" :disabled="isSubmitDisabled" @click="handleCompleteResume">
              Done
              <CheckOutlined class="btn_arrow" />
            </button>
          </div>
        </a-form>
      </a-modal>
      <!-- AI polishing modal -->
      <a-modal
        class="user_center_modal"
        v-model:open="aiPolishingModalVisible"
        @cancel="
          aiPolishingModalVisible = false;
          isSubmitDisabled = false;
          handleDisconnectAIPolishing();
        "
        :footer="null"
      >
        <template #title>
          <img src="@/assets/images/ai_resume.svg" alt="" class="icon" style="margin: 0 5px 5px 0;" />
          <span>AI polishing</span>
        </template>
        <a-form class="modal_form" layout="vertical">
          <a-form-item validateTrigger="blur" label="" name="reason">
            <a-spin class="ai_loading" :spinning="isAiLoading" :indicator="indicator" tip="Loading..." />
            <a-textarea
              style="margin-top:10px;"
              name="search"
              placeholder=""
              :auto-size="{ minRows: 5 }"
              :maxlength="800"
              class="resume_textarea"
              v-model:value="polishedText"
              :readonly="isTyping"
            />
          </a-form-item>
          <div class="tips_wrapper">
            <img src="@/assets/images/tips_tag.svg" alt="" class="icon" />
            The content expanded by AI is for reference only. It is recommended to make modifications based on actual
            circumstances after replacement.
          </div>
          <div class="btn_wrapper">
            <a-button
              class="cancel_btn"
              @click="
                aiPolishingModalVisible = false;
                handleDisconnectAIPolishing();
              "
              >Cancel</a-button
            >
            <a-button
              class="confirm_btn replace_btn"
              type="primary"
              @click.prevent="
                handleReplacePolishedText();
                handleDisconnectAIPolishing();
              "
              :disabled="isTyping"
            >
              Replace
            </a-button>
          </div>
        </a-form>
      </a-modal>
      <!-- AI polishing error modal -->
      <a-modal
        style="z-index: 1001;"
        class="user_center_modal ai_error_modal"
        v-model:open="aiPolishingErrorModalVisible"
        @cancel="aiPolishingErrorModalVisible = false"
        :footer="null"
      >
        <img src="@/assets/images/smile_modal.svg" class="error_icon" alt="" />
        <div class="error_text">{{ aiErrorInfo.text }}</div>

        <a-button
          v-if="aiErrorInfo.state == 1"
          class="confirm_btn"
          type="primary"
          @click.prevent="aiPolishingErrorModalVisible = false"
        >
          OK, I got it
        </a-button>
        <a-button
          v-else-if="aiErrorInfo.state == 2"
          class="confirm_btn"
          type="primary"
          @click.prevent="handleSubmitAIPolishing()"
        >
          Click to retry
        </a-button>
      </a-modal>
      <!-- Change email modal -->
      <a-modal
        class="user_center_modal"
        v-model:open="changeEmailVisible"
        @cancel="changeEmailVisible = false"
        :footer="null"
        title="Change email address"
      >
        <div class="tip">
          You can change your email address after completing the verification of your new email address
        </div>
        <a-form ref="formEmailRef" :model="formState" class="modal_form">
          <EmailInputItem :initial-email="formState.email" @change-email="handleModelChangeEmail" />
          <a-form-item validateTrigger="blur" label="" name="code" :rules="[{ required: true, message: 'Enter code' }]">
            <a-input v-model:value="formState.code" placeholder="Enter code" />
            <button
              class="send_code_btn"
              @click.prevent="sendSMSCode"
              :disabled="isSMSCodeDisabled || isSending"
              :style="{ color: sendSMSCodeText !== 'Send code' || isSending ? 'rgba(61, 61, 61, 0.5)' : '' }"
            >
              <LoadingOutlined v-if="isSending" spin />
              {{ isSending ? 'Sending' : sendSMSCodeText }}
            </button>
          </a-form-item>
          <a-button
            type="primary"
            html-type="button"
            class="submit_btn"
            @click.prevent="handleEmailSubmit"
            :disabled="isSubmitDisabled"
          >
            Done
          </a-button>
        </a-form>
      </a-modal>
      <!-- Position modal -->
      <PositionModal ref="PositionCompleteModalRef" @select-item="handleCompleteSelectPositionItem" />
      <ConfirmModal ref="confirmModalSubmitVideoRef" @confirm="handleSubmitVideoItem" />
      <ConfirmModal ref="confirmModalSubmitVideoRef2" @confirm="handleDeleteVideoItemSubmit" />
      <ConfirmModal ref="confirmModalSubmitVideoRef3" @confirm="handleSubmitEditForm()" @cancel="onCloseDrawer" />
      <ConfirmModal ref="confirmModalDeleteWorkRef" @confirm="handleSubmitDeleteWork()" />
      <ConfirmModal ref="confirmModalDeleteEducationRef" @confirm="handleSubmitDeleteEducation()" />
      <ConfirmModal ref="confirmModalEvaluationRef" @confirm="handleDeleteEvaluationItem()" />
      <ConfirmModal ref="confirmModalEvaluationActiveRef" @confirm="handleDeleteEvaluationActiveItem()" />
      <VideoViewer ref="videoViewerRef" />
      <ImageViewer ref="imageViewerRef" />
      <a-modal
        class="user_center_modal"
        title="Crop Avatar"
        v-model:open="cropperVisible"
        @cancel="handleCropperCancel"
        :footer="null"
      >
        <ImageCropper
          v-if="cropperVisible"
          :image-file="selectedImageFile"
          @confirm="handleCropperConfirm"
          @cancel="handleCropperCancel"
        />
      </a-modal>
    </template>
  </div>
</template>

<script setup>
import { DownOutlined } from '@ant-design/icons-vue';
import { CheckOutlined, LoadingOutlined, RightOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import Cookies from 'js-cookie';
import { ref, onMounted, onUnmounted, reactive, toRaw, h, nextTick, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { companySearch } from '@/api/account/businessVerify.js';
import { loginSubmitByToken } from '@/api/account/login.js';
import { upload, fetchCategoryList } from '@/api/common.js';
import {
  fetchResumeInfo,
  addResume,
  updateResume,
  updateResumeMajor,
  fetchJobSkill,
  updateJobSkill,
  fetchResumeVideo,
  updateResumeVideo,
  updateResumeAdvantage,
  fetchWorkExperience,
  updateWorkExperience,
  addWorkExperience,
  deleteWorkExperience,
  fetchResumeEducation,
  updateResumeEducation,
  addResumeEducation,
  deleteResumeEducation,
  fetchResumeEvaluation,
  fetchResumeActiveEvaluation,
  deleteResumeActiveEvaluation,
  sendResumeEvaluation,
  updateResumeEvaluation,
  updateResumeInfluence,
  updateResumeCurrentTask,
  generateEvaluationToken,
  sendResumeHelp,
  generateHelpToken,
  submitAiPolish,
  getJobCategoryTraitsByName,
  schoolSearch,
  fetchResumeCertificate,
  submitResumeCertificate,
} from '@/api/resume.js';
import { updateEmail, sendVerifyCode } from '@/api/userCenter.js';
import CityInputItem from '@/components/CityInputItem.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import EditResumeSkeleton from '@/components/EditResumeSkeleton.vue';
import EmailInputItem from '@/components/EmailInputItem.vue';
import ImageCropper from '@/components/ImageCropper.vue';
import ImageViewer from '@/components/ImageViewer.vue';
import PositionModal from '@/components/PositionModal.vue';
import ResumeGuideModal from '@/components/ResumeGuideModal.vue';
import ResumePreview from '@/components/ResumePreview.vue';
import Upload from '@/components/Upload.vue';
import { JOB_STATUS_OPTIONS } from '@/constants/jobStatus.js';
import { hydrateVodItems, playSrc, posterSrc, toHttpsUrl, normalizeCoverAt1s } from '@/utils/vod.js';
import VideoViewer from '@/components/VideoViewer.vue';
import defaultVideoCoverImg from '@/assets/images/video.svg';

const store = useStore();
const router = useRouter();

const changeEmailVisible = ref(false);
const formState = reactive({
  email: '',
  code: '',
});
const formEmailRef = ref(null);
const isSMSCodeDisabled = ref(false);
const isSending = ref(false);
const intervalId = ref(null);
const sendSMSCodeText = ref('Send code');
const cropperVisible = ref(false);
const selectedImageFile = ref(null);
const startCountdown = (time) => {
  if (!time) return;
  if (intervalId.value) clearInterval(intervalId.value);
  isSMSCodeDisabled.value = true;
  var timeLeft = time;
  intervalId.value = setInterval(() => {
    if (timeLeft > 0) {
      timeLeft--;
      sendSMSCodeText.value = timeLeft + ' resend';
    } else {
      clearInterval(intervalId.value);
      timeLeft = 60;
      isSMSCodeDisabled.value = false;
      sendSMSCodeText.value = 'Send code';
    }
  }, 1000);
};
const sendSMSCode = () => {
  formEmailRef.value.validateFields(['email']).then(() => {
    isSending.value = true;
    sendVerifyCode({ email: formState.email }).then((res) => {
      isSending.value = false;
      startCountdown(60);
      if (res.code == 0) {
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }
    }).catch(() => {
      isSending.value = false;
    });
  });
};
const handleEmailSubmit = () => {
  formEmailRef.value.validate().then(() => {
    isSubmitDisabled.value = true;
    updateEmail({
      email: formState.email,
      code: formState.code,
    }).then((res) => {
      isSubmitDisabled.value = false;
      if (res.code == 0) {
        message.success(res.msg);
        getResumeInfo();
        changeEmailVisible.value = false;
      } else {
        message.error(res.msg);
      }
    });
  });
};
const handleModelChangeEmail = (email) => {
  formState.email = email;
};
const handleInitChangeEmailModel = () => {
  changeEmailVisible.value = true;
  if (!intervalId.value) {
    // 未发送过验证码：预填当前账号邮箱并重置状态
    formState.email = store.state.currentAccount.email;
    formState.code = '';
    isSMSCodeDisabled.value = false;
    sendSMSCodeText.value = 'Send code';
  } else {
    // 已发送过验证码：保留倒计时与邮箱，只清验证码
    formState.code = '';
  }
};

onUnmounted(() => {
  if (intervalId.value) clearInterval(intervalId.value);
  document.removeEventListener('click', handleVideoActionClickOutside);
});

const indicator = h(LoadingOutlined, {
  style: {
    fontSize: '24px',
    color: '#ffffff',
  },
  spin: true,
});

const confirmModalSubmitVideoRef = ref(null);
const isSubmitDisabled = ref(false);
const isSendingEvaluation = ref(false);
const isSendingHelp = ref(false);

const handleChangeEmail = (email) => {
  if (editType.value == 'name') {
    formNameState.email = email;
  } else if (helpVisible.value) {
    formHelpState.email = email;
  } else if (evaluationVisible.value) {
    formEvaluationState.email = email;
  }
};

const confirmModalSubmitVideoRef3 = ref(null);
const onCloseDrawer = () => {
  open.value = false;
  hasEdit.value = false;
};
const handleCloseDrawer = () => {
  if (hasEdit.value) {
    confirmModalSubmitVideoRef3.value.handelInit({
      content: 'Content has been modified, shall we publish the update?',
      cancelBtnTextVal: 'Discard changes',
      confirmBtnTextVal: 'Publish',
    });
  } else {
    onCloseDrawer();
  }
};

const open = ref(false);
const editType = ref('');
const hasEdit = ref(false);
const handleOpenEditForm = (type) => {
  open.value = true;
  editType.value = type;
  if (type == 'name') {
    formNameState.headUrl = nameState.headUrl;
    formNameState.score = nameState.score;
    formNameState.firstName = nameState.firstName;
    formNameState.lastName = nameState.lastName;
    formNameState.jobStatus = nameState.jobStatus;
    formNameState.city = nameState.city;
    formNameState.email = nameState.email;
    formNameState.mobile = nameState.mobile;
    formNameState.link = nameState.link;
    nextTick(() => {
      hasEdit.value = false;
    });
  } else if (type == 'influence') {
    influenceContentState.value = influenceContent.value;
  } else if (type == 'currentTask') {
    currentTaskState.value = currentTask.value;
  }
};
const setDefaultAvatarImage = (event) => {
  event.target.src = require('@/assets/images/avatar.svg');
};
const hideInvalidImage = (event) => {
  event.target.style.display = 'none';
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 2) {
    const year = parts[0];
    const month = parseInt(parts[1], 10);
    return `${year}-${month}`;
  } else if (parts.length === 3) {
    const year = parts[0];
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);
    return `${year}-${month}-${day}`;
  }
  return dateStr;
};

const showSuggestions = ref(false);
const suggestions = ref([]);
const autoCompleteOptions = ref([]);
const onInput = (event) => {
  showSuggestions.value = true;
  suggestions.value = autoCompleteOptions.value.filter((option) =>
    option.job.toLowerCase().includes(event.target.value.toLowerCase())
  );
};
const selectSuggestion = (item) => {
  if (editType.value == 'work') {
    formWorkState.position = item.job;
    formWorkRef.value.validateFields('position');
  } else if (editType.value == 'video') {
    formViedoState.jobCategoryName = item.job;
    formVideoRef.value.validateFields('jobCategoryName');
  }
  showSuggestions.value = false;
};

// Business name suggestions
const showBusinessSuggestions = ref(false);
const businessSuggestionsRef = ref(null);
const onBusinessInput = (event) => {
  showBusinessSuggestions.value = true;
  handleBusinessSearch(event.target.value);
};
const selectBusinessSuggestion = (item) => {
  formWorkState.companyName = item.value;
  formWorkRef.value.validateFields('companyName');
  showBusinessSuggestions.value = false;
};
const handleBusinessClickOutside = (event) => {
  if (businessSuggestionsRef.value && !businessSuggestionsRef.value.contains(event.target)) {
    showBusinessSuggestions.value = false;
  }
};

// School name suggestions
const showSchoolSuggestions = ref(false);
const schoolSuggestionsRef = ref(null);
const onSchoolInput = (event) => {
  showSchoolSuggestions.value = true;
  handleSchoolSearch(event.target.value);
};
const selectSchoolSuggestion = (item) => {
  formEducationState.school = item.value;
  formEducationRef.value.validateFields('school');
  showSchoolSuggestions.value = false;
};
const handleSchoolClickOutside = (event) => {
  if (schoolSuggestionsRef.value && !schoolSuggestionsRef.value.contains(event.target)) {
    showSchoolSuggestions.value = false;
  }
};

const getCategoryList = () => {
  return fetchCategoryList().then((res) => {
    if (res.code == 0) {
      autoCompleteOptions.value = [
        ...res.data.jobList.map((item) => ({
          job: item.job,
          industry: item.industry,
        })),
        ...res.data.skillList.map((skill) => ({
          job: skill,
          industry: '',
        })),
      ];
    } else {
      message.error(res.msg);
    }
  });
};

const resumeId = ref('');

const resumeModalvisible = ref(false);
const resumePreviewToken = ref('');
const handleOpenPreviewModal = () => {
  resumeModalvisible.value = true;
};

// name logic
const validateInstagramURL = (_, value) => {
  const instagramRegex = /^(https?:\/\/)?(www\.)?instagram\.com\/([\w\-.]+\/?|p\/[\w-]{11}\/?|explore\/tags\/[\w-]+\/?)$/;
  if (!value) {
    return Promise.resolve();
  }
  if (instagramRegex.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('Invalid Instagram URL!'));
};
const isLoading = ref(false);
const formNameRef = ref(null);
const isShowMoreBtn = computed(() => {
  return (
    !nameState.firstName ||
    !nameState.lastName ||
    !nameState.jobStatus ||
    !nameState.city ||
    !nameState.email ||
    !nameState.mobile
  );
});
const nameState = reactive({
  headUrl: '',
  score: 0,
  firstName: '',
  displayName: '',
  lastName: '',
  nickName: '',
  useNicknameInResume: '',
  jobStatus: '',
  city: '',
  email: '',
  mobile: '',
  link: '',
});
const formNameState = reactive({
  headUrl: '',
  score: 0,
  firstName: '',
  lastName: '',
  nickName: '',
  useNicknameInResume: '',
  jobStatus: '',
  city: '',
  email: '',
  mobile: '',
  link: '',
});
const getResumeInfo = () => {
  return fetchResumeInfo().then((res) => {
    if (res.data && res.code == 0) {
      resumeId.value = res.data.resumeId;
      formNameState.score = res.data.score;
      nameState.score = res.data.score;
      formNameState.firstName = res.data.firstName;
      nameState.firstName = res.data.firstName;
      formNameState.lastName = res.data.lastName;
      nameState.lastName = res.data.lastName;
      formNameState.nickName = res.data.nickName;
      nameState.nickName = res.data.nickName;
      nameState.displayName = res.data.displayName;
      formNameState.useNicknameInResume = res.data.useNicknameInResume;
      nameState.useNicknameInResume = res.data.useNicknameInResume;
      formNameState.jobStatus = res.data.jobStatus;
      nameState.jobStatus = res.data.jobStatus;
      formNameState.city = res.data.city;
      nameState.city = res.data.city;
      formNameState.email = res.data.email || formState.email || store.state.currentAccount.email;
      nameState.email = res.data.email || formState.email || store.state.currentAccount.email;
      formNameState.mobile = res.data.mobile;
      nameState.mobile = res.data.mobile;
      formNameState.link = res.data.link;
      nameState.link = res.data.link;
      formNameState.headUrl =
        res.data.headUrl ||
        require('@/assets/images/avatar/avatar_default_' + (Math.floor(Math.random() * 10) + 1) + '.svg');
      nameState.headUrl =
        res.data.headUrl ||
        require('@/assets/images/avatar/avatar_default_' + (Math.floor(Math.random() * 10) + 1) + '.svg');
      advantageContent.value = res.data.advantage;
      advantageContentState.value = res.data.advantage;
      influenceContent.value = res.data.influence;
      influenceContentState.value = res.data.influence;
      currentTask.value = res.data.currentTask;
      currentTaskState.value = res.data.currentTask;
      resumePreviewToken.value = res.data.token;
      getResumeVideo();
      // complete logic
      formCompleteState.jobStatus = formNameState.jobStatus ? formNameState.jobStatus : 'Part-time';
      completeState.jobStatus = formNameState.jobStatus;
      formCompleteState.city = formNameState.city;
      completeState.city = formNameState.city;
      if (!formCompleteState.jobStatus || !formCompleteState.city) {
        completeVisible.value = true;
      }
    } else {
      message.error(res.msg);
    }
  });
};
const jdInput = ref(null);
const handleUploadClick = () => {
  jdInput.value && jdInput.value.click();
};
const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  // 打开图像剪裁模态框
  selectedImageFile.value = file;
  cropperVisible.value = true;
};

const handleCropperConfirm = (compressedFile) => {
  isLoading.value = true;

  const formData = new FormData();
  formData.append('file', compressedFile);
  formData.append('folder', 1);

  upload(formData)
    .then((res) => {
      isLoading.value = false;
      cropperVisible.value = false;
      // 重置文件输入框
      if (jdInput.value) {
        jdInput.value.value = '';
      }

      if (res.code == 0) {
        message.success(res.msg);
        formNameState.headUrl = res.data.fileUrl;
      } else {
        message.error(res.msg);
      }
    })
    .catch((error) => {
      isLoading.value = false;
      cropperVisible.value = false;
      // 重置文件输入框
      if (jdInput.value) {
        jdInput.value.value = '';
      }
      message.error('Upload failed, please try again');
      console.error('Upload error:', error);
    });
};

const handleCropperCancel = () => {
  cropperVisible.value = false;
  // 重置文件输入框
  if (jdInput.value) {
    jdInput.value.value = '';
  }
};
const isLandscape = (url) => {
  const img = new Image();
  img.src = url;
  return img.width > img.height;
};
const handleChangeCity = (item) => {
  formNameState.city = item;
};
const handleChangeCompleteCity = (item) => {
  formCompleteState.city = item;
};
watch(
  formNameState,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// position logic
const PositionModalRef = ref(null);
const isEditPositionModal = ref(false);
const formPositionState = reactive({
  resumeId: '',
  resumeJobSkillId: '',
  jobCategoryName: '',
  level: '',
  index: null,
});
const handlePositionModalOpen = (type, item, index) => {
  if (type == 'edit') {
    isEditPositionModal.value = true;
    formPositionState.resumeId = item.resumeId;
    formPositionState.resumeJobSkillId = item.resumeJobSkillId;
    formPositionState.jobCategoryName = item.jobCategoryName;
    formPositionState.level = item.level;
    formPositionState.index = index;
    PositionModalRef.value.updateName(item.jobCategoryName);
  } else {
    formPositionState.index = null;
    isEditPositionModal.value = false;
  }
  PositionModalRef.value.open();
};
const positionList = ref([]);
const formPositionList = ref([]);
const getPositionList = () => {
  return fetchJobSkill().then((res) => {
    if (res.code == 0) {
      positionList.value = res.data;
      formCompleteState.jobSkills = JSON.parse(JSON.stringify(res.data));
      completeState.jobSkills = JSON.parse(JSON.stringify(res.data));
      formPositionList.value = JSON.parse(JSON.stringify(positionList.value));
    } else {
      message.error(res.msg);
    }
    if (completeState.jobSkills.length == 0) {
      completeVisible.value = true;
    }
  });
};
const handleSelectPositionItem = (positionItem, skillItem) => {
  const positionState = {
    jobCategoryId: positionItem.categoryId,
    jobCategoryName: positionItem.categoryName,
    level: positionItem.level,
    jobSkills: [],
  };

  if (skillItem) {
    for (const data of skillItem) {
      const skillState = {
        jobCategoryId: data.categoryId,
        jobCategoryName: data.categoryName,
        level: data.level,
      };
      positionState.jobSkills.push(skillState);
    }
  }

  const existingIndex = formPositionList.value.findIndex((i) => i.jobCategoryId == positionState.jobCategoryId);

  if (existingIndex >= 0 && existingIndex != formPositionState.index) {
    message.error('Related positions already exist.');
  } else {
    if (formPositionState.index !== null) {
      formPositionList.value[formPositionState.index] = positionState;
    } else {
      formPositionList.value.push(positionState);
    }
  }
};
const handleDeletePositionItem = (jobCategoryId) => {
  if (formPositionList.value.length <= 1) {
    message.warning('At least one position must be retained.');
    return;
  }
  formPositionList.value = formPositionList.value.filter((item) => item.jobCategoryId !== jobCategoryId);
};
const handleSortPositionItem = (type, item) => {
  const index = formPositionList.value.findIndex((i) => i.jobCategoryId === item.jobCategoryId);
  if (type === 'up' && index > 0) {
    const temp = formPositionList.value[index - 1];
    formPositionList.value[index - 1] = formPositionList.value[index];
    formPositionList.value[index] = temp;
  } else if (type === 'down' && index < formPositionList.value.length - 1) {
    const temp = formPositionList.value[index + 1];
    formPositionList.value[index + 1] = formPositionList.value[index];
    formPositionList.value[index] = temp;
  }
};
const handleModifyPositionItem = (name) => {
  formPositionList.value = formPositionList.value.map((item) => {
    if (item.resumeJobSkillId === formPositionState.resumeJobSkillId) {
      return {
        ...item,
        jobCategoryName: name,
      };
    }
    return item;
  });
};
watch(
  formPositionList,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// video logic
const uploadRef = ref(null);
const formVideoRef = ref(null);
const videoVisible = ref(false);
const isVideoEdit = ref(false);
const videoList = ref([]);
const formVideoList = ref([]);
const formViedoState = reactive({
  resumeVideoId: '',
  editKey: '',
  videoUrl: '',
  coverUrl: '',
  playUrl: '',
  jobCategoryName: '',
});
// 新上传未发布的视频没有 resumeVideoId，用前端临时唯一 key 标识，避免按 undefined 匹配时误伤同批其他视频
let videoLocalSeq = 0;
const getVideoKey = (video) => (video.resumeVideoId != null ? `db_${video.resumeVideoId}` : video._localId);
// 列表封面：OSS 对刚上传的视频首次截帧可能未就绪（poster 加载失败不会自动重试），
// 先显示本地临时截图/默认图，预加载成功后替换为 OSS 截帧 URL，失败则 3 秒后重试（最多 5 次）
const defaultVideoCover = defaultVideoCoverImg;
const buildSnapshotUrl = (videoUrl) => videoUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_500,ar_auto';
const setupPoster = (item) => {
  if (item.coverUrl) {
    const cover = String(item.coverUrl);
    const normalized = cover.startsWith('data:') ? cover : normalizeCoverAt1s(toHttpsUrl(cover));
    item.posterUrl = normalized;
    // 本地临时截图之外的封面，若是视频 URL 则已被 normalize 成 1s 截帧，无需再预加载
    if (!cover.startsWith('data:')) {
      return;
    }
  }
  const src = playSrc(item);
  if (!src || src.includes('.m3u8') || src.includes('?')) return;
  const url = buildSnapshotUrl(src);
  const img = new Image();
  img.onload = () => {
    item.posterUrl = url;
  };
  img.onerror = () => {
    item._posterRetry = (item._posterRetry || 0) + 1;
    if (item._posterRetry <= 5) {
      setTimeout(() => setupPoster(item), 3000);
    }
  };
  img.src = url;
};
// 点击排序后抑制所有卡片的操作蒙版；鼠标移出视频区域后恢复，之后 hover 再正常显示。
// 注意不能用"卡片级 mouseleave 清除标记"：排序导致 DOM 移动时会立刻触发 mouseleave，标记瞬间失效
const sortMaskSuppressed = ref(false);
// 触屏设备没有 hover：点击视频右上角三个点展开操作层（与网页版一致，盖在视频上）
const activeVideoActionKey = ref('');
const toggleVideoAction = (item) => {
  const key = getVideoKey(item);
  activeVideoActionKey.value = activeVideoActionKey.value === key ? '' : key;
};
// 点击视频区域外收起操作层，恢复三点图标
const handleVideoActionClickOutside = (e) => {
  if (!activeVideoActionKey.value) return;
  if (e.target.closest && e.target.closest('.video.action_open, .video_more_btn')) return;
  activeVideoActionKey.value = '';
};
const confirmModalSubmitVideoRef2 = ref(null);
const getResumeVideo = () => {
  fetchResumeVideo({ resumeId: resumeId }).then(async (res) => {
    if (res.code == 0) {
      videoList.value = res.data || [];
      await hydrateVodItems(videoList.value);
      videoList.value.forEach(setupPoster);
      formVideoList.value = JSON.parse(JSON.stringify(videoList.value));
      formVideoList.value.forEach(setupPoster);
    } else {
      message.error(res.msg);
    }
  });
};
const initVideoModal = (type, item) => {
  if (type === 'add') {
    formViedoState.resumeVideoId = '';
    formViedoState.editKey = '';
    formViedoState.videoUrl = '';
    formViedoState.coverUrl = '';
    formViedoState.playUrl = '';
    formViedoState.jobCategoryName = '';
    videoVisible.value = true;
    isVideoEdit.value = false;
    nextTick(() => {
      uploadRef.value.handleInitFormState();
    });
  } else if (type === 'edit') {
    formViedoState.resumeVideoId = item.resumeVideoId;
    formViedoState.editKey = getVideoKey(item);
    formViedoState.videoUrl = item.videoUrl;
    formViedoState.coverUrl = item.coverUrl || '';
    formViedoState.playUrl = item.playUrl || '';
    formViedoState.jobCategoryName = item.jobCategoryName;
    videoVisible.value = true;
    isVideoEdit.value = true;
    nextTick(() => {
      uploadRef.value.handleInitFormState(item.videoUrl);
    });
  }
};
const handleOnUploaded = (fileUrl) => {
  formViedoState.videoUrl = fileUrl;
};
const handleOnUploadedWithCover = (fileUrl, fileType, coverUrl, playUrl) => {
  formViedoState.videoUrl = fileUrl;
  formViedoState.coverUrl = coverUrl;
  formViedoState.playUrl = playUrl || '';
};
const doSubmitVideoChange = () => {
  if (!formViedoState.videoUrl) {
    message.error('Please upload a video');
    return;
  }
  formVideoRef.value.validateFields(['jobCategoryName']).then(() => {
    uploadRef.value.handleInitFormState();
    videoVisible.value = false;
    if (isVideoEdit.value) {
      formVideoList.value = formVideoList.value.map((item) => {
        if (getVideoKey(item) === formViedoState.editKey) {
          const updated = {
            resumeVideoId: formViedoState.resumeVideoId,
            _localId: item._localId,
            videoUrl: formViedoState.videoUrl,
            coverUrl: formViedoState.coverUrl,
            playUrl: formViedoState.playUrl,
            jobCategoryName: formViedoState.jobCategoryName,
          };
          // 视频可能已更换，重新走 OSS 截帧预加载；替换前先沿用旧封面避免黑屏
          updated.posterUrl = item.posterUrl;
          setupPoster(updated);
          return updated;
        }
        return item;
      });
    } else {
      const added = {
        _localId: `local_${Date.now()}_${videoLocalSeq++}`,
        videoUrl: formViedoState.videoUrl,
        coverUrl: formViedoState.coverUrl,
        playUrl: formViedoState.playUrl,
        jobCategoryName: formViedoState.jobCategoryName,
        // 上传完成时已带本地临时截图（dataURL），先立即显示
        posterUrl: formViedoState.coverUrl,
      };
      setupPoster(added);
      formVideoList.value.push(added);
    }
  });
};
const handleViewVideoItem = (item) => {
  handleInitVideoView([item], 0);
};
const handleDeleteVideoItem = (item) => {
  formViedoState.editKey = getVideoKey(item);
  confirmModalSubmitVideoRef2.value.handelInit({
    content: 'Are you sure you want to delete this video?',
  });
};
const handleDeleteVideoItemSubmit = () => {
  formVideoList.value = formVideoList.value.filter((video) => getVideoKey(video) !== formViedoState.editKey);
  activeVideoActionKey.value = '';
};
const handleFirstVideoItem = (item) => {
  sortMaskSuppressed.value = true;
  const index = formVideoList.value.findIndex((video) => getVideoKey(video) === getVideoKey(item));
  if (index > 0) {
    const firstItem = formVideoList.value[0];
    formVideoList.value[0] = formVideoList.value[index];
    formVideoList.value[index] = firstItem;
  }
};
const handleUpVideoItem = (item) => {
  sortMaskSuppressed.value = true;
  const index = formVideoList.value.findIndex((video) => getVideoKey(video) === getVideoKey(item));
  if (index > 0) {
    const temp = formVideoList.value[index - 1];
    formVideoList.value[index - 1] = formVideoList.value[index];
    formVideoList.value[index] = temp;
  }
};
const handleDownVideoItem = (item) => {
  sortMaskSuppressed.value = true;
  const index = formVideoList.value.findIndex((video) => getVideoKey(video) === getVideoKey(item));
  if (index < formVideoList.value.length - 1) {
    const temp = formVideoList.value[index + 1];
    formVideoList.value[index + 1] = formVideoList.value[index];
    formVideoList.value[index] = temp;
  }
};
const handleLastVideoItem = (item) => {
  sortMaskSuppressed.value = true;
  const index = formVideoList.value.findIndex((video) => getVideoKey(video) === getVideoKey(item));
  if (index < formVideoList.value.length - 1) {
    const lastItem = formVideoList.value[formVideoList.value.length - 1];
    formVideoList.value[formVideoList.value.length - 1] = formVideoList.value[index];
    formVideoList.value[index] = lastItem;
  }
};
const handleSubmitVideoItem = () => {
  // 前端临时字段不提交；coverUrl 若是本地截图 dataURL（体积大），转回 OSS 截帧 URL 再提交
  const list = formVideoList.value.map(({ _localId, _posterRetry, posterUrl, playUrl, coverUrl, videoUrl, ...rest }) => ({
    ...rest,
    videoUrl,
    coverUrl: coverUrl && coverUrl.startsWith('data:') ? undefined : coverUrl,
  }));
  updateResumeVideo({ list }).then((res) => {
    if (res.code == 0) {
      message.success(res.msg);
      getResumeInfo();
      onCloseDrawer();
    } else {
      message.error(res.msg);
    }
  });
};
const videoViewerRef = ref(null);
const handleInitVideoView = (videoListTmp, index) => {
  videoViewerRef.value.openViewer(videoListTmp, index);
};
const handleMouseEnter = (event) => {
  const video = event.target;
  if (!video || !video.play || !video.currentSrc) return;
  video.muted = true;
  video.play();
};
const handleMouseLeave = (event) => {
  const video = event.target;
  video.pause();
};
const paintFirstFrame = (video) => {
  if (!video || video.readyState < 1) return;
  if (video.currentTime > 0) return;
  try {
    video.currentTime = video.duration > 1 ? 1 : (video.duration > 0.2 ? 0.1 : 0.01);
  } catch (e) {
    // ignore
  }
};
const videoDurationList = ref([]);
const getVideoDuration = (index) => {
  const el = document.getElementById('videoPlayer' + index);
  if (!el) return;
  videoDurationList.value[index] = el.duration;
  paintFirstFrame(el);
};
const formatToMinutes = (seconds) => {
  const totalSeconds = Math.floor(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
watch(
  formVideoList,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// cert logic
const uploadCertRef = ref(null);
const formCertRef = ref(null);
const imageViewerRef = ref(null);
const certVisible = ref(false);
const isCertEdit = ref(false);
const currentUrl = ref('');
const currentIndex = ref(0);
const certState = reactive({
  description: '',
  imageUrls: [],
});
const formCertState = reactive({
  description: '',
  imageUrls: [],
});
const getResumeCert = () => {
  return fetchResumeCertificate().then((res) => {
    if (res.code == 0) {
      certState.description = res.data.description;
      certState.imageUrls = res.data.imageUrls ? res.data.imageUrls.split(',').map((item) => item.trim()) : [];
      formCertState.description = res.data.description;
      formCertState.imageUrls = res.data.imageUrls ? res.data.imageUrls.split(',').map((item) => item.trim()) : [];
    } else {
      message.error(res.msg);
    }
  });
};
const initCertModal = (type, item, index) => {
  if (type === 'add') {
    certVisible.value = true;
    isCertEdit.value = false;
    nextTick(() => {
      uploadCertRef.value.handleInitFormState();
    });
  } else if (type === 'edit') {
    currentUrl.value = item;
    currentIndex.value = index;
    certVisible.value = true;
    isCertEdit.value = true;
    nextTick(() => {
      uploadCertRef.value.handleInitFormState(item);
    });
  }
};
const handleOnCertUploaded = (fileUrl) => {
  currentUrl.value = fileUrl;
};
const doSubmitCertChange = () => {
  certVisible.value = false;
  if (!isCertEdit.value) {
    formCertState.imageUrls.push(currentUrl.value);
  } else {
    formCertState.imageUrls[currentIndex.value] = currentUrl.value;
  }
};
const handleDeleteCertItem = (index) => {
  formCertState.imageUrls = formCertState.imageUrls.filter((_, i) => i !== index);
};
const handleInitImageView = (url) => {
  imageViewerRef.value.openViewer(url);
};

// advantage logic
const polishedText = ref('');
const aiPolishingModalVisible = ref(false);
const aiPolishingErrorModalVisible = ref(false);
const aiErrorInfo = reactive({
  text: '',
  state: 1, // 1: no msg, 2: retry
});
const advantageContent = ref('');
const advantageContentState = ref('');
const skillVisible = ref(false);
const skillList = ref([]);
const selectedSkillList = ref([]);
const handleInitSkillModal = () => {
  getJobCategoryTraitsByName({
    jobCategoryNames: formPositionList.value.map((item) => item.jobCategoryName),
  }).then((res) => {
    if (res.code == 0) {
      if (res.data && res.data.length > 0) {
        skillList.value = res.data;
        selectedSkillList.value = [];
        skillVisible.value = true;
      } else {
        handleSubmitAIPolishing();
      }
    } else {
      message.error(res.msg);
    }
  });
};
const handleClickSkillItem = (item) => {
  if (selectedSkillList.value.some((skill) => skill === item)) {
    selectedSkillList.value = selectedSkillList.value.filter((skill) => skill !== item);
  } else {
    selectedSkillList.value.push(item);
  }
};

const isConnected = ref(false);
const isAiLoading = ref(false);
const handleSubmitAIPolishing = async () => {
  if (isConnected.value) {
    message.error('Connecting...');
    return;
  }

  skillVisible.value = false;
  isAiLoading.value = true;

  let polishType = '';
  let originText = '';
  if (editType.value == 'advantage') {
    originText = advantageContentState.value;
    polishType = 'advantage';
  } else if (editType.value == 'work') {
    originText = formWorkState.description;
    polishType = 'experience';
  } else if (editType.value == 'education') {
    originText = formEducationState.description;
    polishType = 'edu_experience';
  }
  if (!formWorkState.position && editType.value == 'work') {
    aiErrorInfo.text = 'Please enter the job position first, and the AI will write for you.';
    aiErrorInfo.state = 1;
    aiPolishingErrorModalVisible.value = true;
    skillVisible.value = false;
    return;
  }
  if ((!originText || originText.trim() === '') && editType.value != 'advantage' && editType.value != 'work') {
    aiErrorInfo.text = 'Please fill in the main content first before polishing it.';
    aiErrorInfo.state = 1;
    aiPolishingErrorModalVisible.value = true;
    skillVisible.value = false;
    return;
  }
  isTyping.value = true;
  aiPolishingModalVisible.value = true;
  aiPolishingErrorModalVisible.value = false;
  polishedText.value = '';

  const url = `/api/resume/stream/aiPolish`;
  const formData = {
    originText: originText,
    position:
      editType.value == 'work'
        ? formWorkState.position
        : formPositionList.value.map((item) => item.jobCategoryName).join(','),
    polishType: polishType,
    keywords: editType.value == 'advantage' ? selectedSkillList.value.join(',') : '',
  };

  try {
    const token = store.getters.getToken;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
        'Cache-Control': 'no-cache',
        Authorization: token ? `Bearer ${token}` : '',
      },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    isConnected.value = true;

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    let buffer = '';

    while (isConnected.value) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      let lines = buffer.split('\n');
      buffer = lines.pop(); // 保留最后可能不完整的部分

      for (let line of lines) {
        isAiLoading.value = false;
        line = line.replace(/\r$/, ''); // 仅去掉行尾回车，保留载荷内的原始空格
        if (!line.trim()) continue;

        if (line.startsWith('data:') && aiPolishingModalVisible.value) {
          let data = line.substring(5);
          if (data.startsWith(' ')) data = data.substring(1); // SSE 规范：仅去掉 "data:" 后的一个分隔空格，保留载荷内的原始空格
          data = data.replace(/\r$/, '');
          if (data) {
            await startTyping(attachSpace(data));
          }
        } else if (line.startsWith('event:')) {
          const event = line.substring(6).trim();
          if (event === 'end' || event === 'complete' || event === 'finished') {
            setTimeout(() => {
              handleDisconnectAIPolishing();
            }, 1000);
            return;
          }
        }
      }
    }
  } catch (error) {
    console.error('SSE Error:', error);
  }
};
const handleDisconnectAIPolishing = () => {
  isConnected.value = false;
};

// AI typing effect logic
const isTyping = ref(false);
// 后端 SSE 流丢失了 token 间的原始空格，这里按英文排版规则启发式补回；
// 若后端修复为原样透传（片段自带空格），本函数会直接放行，无需回滚
const attachSpace = (seg) => {
  const cur = polishedText.value;
  if (!cur || /^\s/.test(seg)) return seg;
  const prev = cur.slice(-1);
  const first = seg[0];
  if (/[\u4e00-\u9fff]/.test(prev) || /[\u4e00-\u9fff]/.test(first)) return seg; // 中文之间不加空格
  const prevOk = /[A-Za-z0-9,.;:!?%)\]"'”’]/.test(prev); // 英数或闭合标点之后
  const firstOk = /^[A-Za-z0-9(\[{“"]/.test(first);      // 英数或开放标点之前（撇号/连字符除外，如 It's、detail-oriented）
  return prevOk && firstOk ? ' ' + seg : seg;
};
const startTyping = (msg) => {
  return new Promise((resolve) => {
    isTyping.value = true;
    let typingInterval = null;
    let typeIndex = 0;
    typingInterval = setInterval(() => {
      if (typeIndex < msg.length && polishedText.value.length < 800) {
        polishedText.value += msg.charAt(typeIndex);
        typeIndex++;
      } else {
        isTyping.value = false;
        clearInterval(typingInterval);
        resolve();
      }
    }, 50);
  });
};
const handleReplacePolishedText = () => {
  if (editType.value == 'advantage') {
    advantageContent.value = polishedText.value;
    advantageContentState.value = polishedText.value;
  } else if (editType.value == 'work') {
    formWorkState.description = polishedText.value;
  } else if (editType.value == 'education') {
    formEducationState.description = polishedText.value;
  }
  aiPolishingModalVisible.value = false;
};

watch(
  advantageContentState,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// Work logic
const formWorkRef = ref(null);
const formWorkState = reactive({
  companyName: '',
  position: '',
  startDate: '',
  endDate: '',
  description: '',
  resumeExperienceId: '',
});
const workExperienceList = ref([]);
const businessList = ref([]);
const confirmModalDeleteWorkRef = ref(null);
const handleBusinessSearch = (name) => {
  companySearch(name).then((res) => {
    if (res.code == 0) {
      businessList.value = res.data
        .map((item) => ({
          value: item.name,
          label: item.name,
        }))
        .slice(0, 10);
    }
  });
};
const handleBusinessSelect = (value) => {
  formWorkState.companyName = value;
};
const getWorkExperienceList = () => {
  return fetchWorkExperience().then((res) => {
    if (res.code == 0) {
      workExperienceList.value = res.data;
    } else {
      message.error(res.msg);
    }
  });
};
const handleInitWorkExperienceForm = (item) => {
  if (item) {
    formWorkState.companyName = item.companyName || '';
    formWorkState.position = item.position || '';
    formWorkState.startDate = item.startDate || '';
    formWorkState.endDate = item.endDate || '';
    formWorkState.description = item.description || '';
    formWorkState.resumeExperienceId = item.resumeExperienceId || '';
  } else {
    formWorkState.companyName = '';
    formWorkState.position = '';
    formWorkState.startDate = '';
    formWorkState.endDate = '';
    formWorkState.description = '';
    formWorkState.resumeExperienceId = '';
  }
  nextTick(() => {
    handleOpenEditForm('work');
  });
};
const disabledStartDate = (current) => {
  if (!formWorkState.endDate) {
    return false;
  }
  const endDate = new Date(formWorkState.endDate);
  return endDate && current > endDate;
};
const disabledEndDate = (current) => {
  if (!formWorkState.startDate) {
    return false;
  }
  const startDate = new Date(formWorkState.startDate);
  return startDate && current < startDate;
};
const initDeleteWorkExperience = () => {
  confirmModalDeleteWorkRef.value.handelInit({
    content: 'Are you sure you want to delete this work experience?',
  });
};
const handleSubmitDeleteWork = () => {
  deleteWorkExperience({ resumeExperienceId: formWorkState.resumeExperienceId, resumeId: resumeId.value }).then(
    (res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getResumeInfo();
        getWorkExperienceList();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    }
  );
};
watch(
  formWorkState,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// Education logic
const startYear = 1999;
const endYear = 2039;
const datesRange = ref([]);
const disabledDate = (current) => {
  return current.year() < startYear || current.year() > endYear;
};
const formEducationState = reactive({
  resumeEducationId: '',
  school: '',
  degree: '',
  major: '',
  startDate: '',
  endDate: '',
  description: '',
});
const formEducationRef = ref(null);
const confirmModalDeleteEducationRef = ref(null);
const educationList = ref([]);
const schoolList = ref([]);
const handleSchoolSearch = (name) => {
  schoolSearch({
    pageNum: 1,
    educationName: name,
    pageSize: 10,
  }).then((res) => {
    if (res.code == 0) {
      schoolList.value = res.data.list.map((item) => ({
        value: item.educationName,
        label: item.educationName,
      }));
    }
  });
};
const handleSchoolSelect = (value) => {
  formEducationState.school = value;
};
const handleDatesRangeChange = () => {
  if (datesRange.value && datesRange.value.length === 2) {
    formEducationState.startDate = datesRange.value[0];
    formEducationState.endDate = datesRange.value[1];
  } else {
    formEducationState.startDate = '';
    formEducationState.endDate = '';
  }
};
const getEducationListList = () => {
  return fetchResumeEducation().then((res) => {
    if (res.code == 0) {
      educationList.value = res.data;
    } else {
      message.error(res.msg);
    }
  });
};
const handleInitEducationForm = (item) => {
  if (item) {
    formEducationState.resumeEducationId = item.resumeEducationId || '';
    formEducationState.school = item.school || '';
    formEducationState.degree = item.degree || '';
    formEducationState.major = item.major || '';
    formEducationState.startDate = item.startDate || '';
    formEducationState.endDate = item.endDate || '';
    datesRange.value = [item.startDate, item.endDate];
    formEducationState.description = item.description || '';
  } else {
    formEducationState.resumeEducationId = '';
    formEducationState.school = '';
    formEducationState.degree = '';
    formEducationState.major = '';
    formEducationState.startDate = '';
    formEducationState.endDate = '';
    datesRange.value = [];
    formEducationState.description = '';
  }
  nextTick(() => {
    handleOpenEditForm('education');
  });
};
const initDeleteEducation = () => {
  confirmModalDeleteEducationRef.value.handelInit({
    content: 'Are you sure you want to delete this education experience?',
  });
};
const handleSubmitDeleteEducation = () => {
  deleteResumeEducation({ resumeEducationId: formEducationState.resumeEducationId, resumeId: resumeId.value }).then(
    (res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getResumeInfo();
        getEducationListList();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    }
  );
};
watch(
  formEducationState,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// evaluation logic
const evaluationVisible = ref(false);
const evaluationStep = ref(1);
const evaluationList = ref([]);
const evaluationActiveList = ref([]);
const formEvaluationList = ref([]);
const confirmModalEvaluationRef = ref(null);
const confirmModalEvaluationActiveRef = ref(null);
const formEvaluationState = reactive({
  email: '',
  evaluationId: '',
  invitationId: '',
});
const formEvaluationRef = ref(null);
const getEvaluationList = () => {
  return fetchResumeEvaluation().then((res) => {
    if (res.code == 0) {
      evaluationList.value = res.data;
      formEvaluationList.value = JSON.parse(JSON.stringify(evaluationList.value));
    } else {
      message.error(res.msg);
    }
  });
};
const getEvaluationActiveList = () => {
  return fetchResumeActiveEvaluation().then((res) => {
    if (res.code == 0) {
      evaluationActiveList.value = res.data;
    } else {
      message.error(res.msg);
    }
  });
};
const handleDeleteEvaluationActiveItem = () => {
  deleteResumeActiveEvaluation(formEvaluationState.invitationId).then((res) => {
    if (res.code == 0) {
      getEvaluationActiveList();
      message.success(res.msg);
    } else {
      message.error(res.msg);
    }
  });
};
const initDeleteEvaluationActiveItem = (invitationId) => {
  formEvaluationState.invitationId = invitationId;
  confirmModalEvaluationActiveRef.value.handelInit({
    content: 'Are you sure you want to cancel the invitation?',
  });
};
const handleEvaluationSection = (type) => {
  if (type === 'email') {
    evaluationStep.value = 2;
    formEvaluationState.email = '';
  } else if (type === 'link') {
    generateEvaluationToken().then((res) => {
      if (res.code == 0) {
        handleCopyContact(res.data);
      } else {
        message.error(res.msg);
      }
    });
  }
};
const handleSubmitEmailEvaluation = () => {
  formEvaluationRef.value.validate().then(() => {
    isSubmitDisabled.value = true;
    isSendingEvaluation.value = true;
    sendResumeEvaluation({ email: formEvaluationState.email })
      .then((res) => {
        if (res.code == 0) {
          message.success(res.msg);
          evaluationStep.value = 1;
          evaluationVisible.value = false;
          getEvaluationList();
          getEvaluationActiveList();
        } else {
          message.error(res.msg);
        }
      })
      .finally(() => {
        isSubmitDisabled.value = false;
        isSendingEvaluation.value = false;
      });
  });
};
const initDeleteEvaluationItem = (evaluationId) => {
  formEvaluationState.evaluationId = evaluationId;
  confirmModalEvaluationRef.value.handelInit({
    content: 'Are you sure you want to cancel the invitation?',
  });
};
const handleDeleteEvaluationItem = () => {
  formEvaluationList.value = formEvaluationList.value.filter(
    (item) => item.evaluationId !== formEvaluationState.evaluationId
  );
};
const handleUpEvaluationItem = (evaluationId) => {
  const index = formEvaluationList.value.findIndex((item) => item.evaluationId === evaluationId);
  if (index > 0) {
    const temp = formEvaluationList.value[index - 1];
    formEvaluationList.value[index - 1] = formEvaluationList.value[index];
    formEvaluationList.value[index] = temp;
  }
};
const handleDownEvaluationItem = (evaluationId) => {
  const index = formEvaluationList.value.findIndex((item) => item.evaluationId === evaluationId);
  if (index < formEvaluationList.value.length - 1) {
    const temp = formEvaluationList.value[index + 1];
    formEvaluationList.value[index + 1] = formEvaluationList.value[index];
    formEvaluationList.value[index] = temp;
  }
};
watch(
  formEvaluationList,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// influence logic
const influenceContent = ref('');
const influenceContentState = ref('');
watch(
  influenceContentState,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

// currentTask logic
const currentTask = ref('');
const currentTaskState = ref('');
watch(
  currentTaskState,
  () => {
    if (open.value) {
      hasEdit.value = true;
    }
  },
  { deep: true }
);

const handleSubmitEditForm = () => {
  if (editType.value == 'name') {
    if (!formNameState.firstName) {
      message.error('Please enter first name');
      return;
    } else if (!formNameState.lastName) {
      message.error('Please enter last name');
      return;
    } else if (!formNameState.jobStatus) {
      message.error('Please enter jobStatus');
      return;
    } else if (!formNameState.city) {
      message.error('Please enter city');
      return;
    } else if (!formNameState.nickName && formNameState.useNicknameInResume) {
      message.error('Please enter nickName');
      return;
    }
    if (resumeId.value) {
      formNameRef.value.validate().then(() => {
        updateResume({ ...toRaw(formNameState), resumeId: resumeId.value }).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            getResumeInfo();
            onCloseDrawer();
          } else {
            message.error(res.msg);
          }
        });
      });
    } else {
      formNameRef.value.validate().then(() => {
        addResume({ ...toRaw(formNameState), resumeId: resumeId.value }).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            getResumeInfo();
            onCloseDrawer();
          } else {
            message.error(res.msg);
          }
        });
      });
    }
  } else if (editType.value == 'position') {
    updateJobSkill({ list: formPositionList.value }).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getPositionList();
        getResumeInfo();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    });
  } else if (editType.value == 'video') {
    handleSubmitVideoItem();
  } else if (editType.value == 'advantage') {
    updateResumeAdvantage({ resumeId: resumeId.value, advantage: advantageContentState.value }).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getResumeInfo();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    });
  } else if (editType.value == 'work') {
    if (!formWorkState.companyName) {
      message.error('Please enter company name');
      return;
    } else if (!formWorkState.startDate) {
      message.error('Please enter start date');
      return;
    } else if (!formWorkState.position) {
      message.error('Please enter position');
      return;
    } else if (!formWorkState.description) {
      message.error('Please enter description');
      return;
    }
    if (formWorkState.resumeExperienceId) {
      formWorkRef.value.validate().then(() => {
        updateWorkExperience({ ...toRaw(formWorkState), resumeId: resumeId.value }).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            getWorkExperienceList();
            getResumeInfo();
            onCloseDrawer();
          } else {
            message.error(res.msg);
          }
        });
      });
    } else {
      formWorkRef.value.validate().then(() => {
        addWorkExperience({ ...toRaw(formWorkState), resumeId: resumeId.value }).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            getWorkExperienceList();
            getResumeInfo();
            onCloseDrawer();
          } else {
            message.error(res.msg);
          }
        });
      });
    }
  } else if (editType.value == 'education') {
    // const startYear = new Date(formEducationState.startDate).getFullYear();
    // const calculatedEndYear = startYear + 4;
    // const currentYear = new Date().getFullYear();
    // formEducationState.endDate =
    //   calculatedEndYear > currentYear ? `${currentYear}-01-01` : `${calculatedEndYear}-01-01`;
    if (!formEducationState.school) {
      message.error('Please enter school');
      return;
    } else if (!formEducationState.startDate) {
      message.error('Please enter start date');
      return;
    } else if (!formEducationState.endDate) {
      message.error('Please enter end date');
      return;
    } else if (!formEducationState.degree) {
      message.error('Please enter degree');
      return;
    }
    if (formEducationState.resumeEducationId) {
      formEducationRef.value.validate().then(() => {
        updateResumeEducation({ ...toRaw(formEducationState), resumeId: resumeId.value }).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            getEducationListList();
            getResumeInfo();
            onCloseDrawer();
          } else {
            message.error(res.msg);
          }
        });
      });
    } else {
      formEducationRef.value.validate().then(() => {
        addResumeEducation({ ...toRaw(formEducationState), resumeId: resumeId.value }).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            getEducationListList();
            getResumeInfo();
            onCloseDrawer();
          } else {
            message.error(res.msg);
          }
        });
      });
    }
  } else if (editType.value == 'evaluation') {
    updateResumeEvaluation({
      evaluationList: formEvaluationList.value,
    }).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getEvaluationList();
        getResumeInfo();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    });
  } else if (editType.value == 'influence') {
    updateResumeInfluence({ resumeId: resumeId.value, influence: influenceContentState.value }).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getResumeInfo();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    });
  } else if (editType.value == 'currentTask') {
    updateResumeCurrentTask({ resumeId: resumeId.value, currentTask: currentTaskState.value }).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getResumeInfo();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    });
  } else if (editType.value == 'certificate') {
    submitResumeCertificate({
      description: formCertState.description,
      imageUrls: formCertState.imageUrls.join(','),
    }).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        getResumeCert();
        onCloseDrawer();
      } else {
        message.error(res.msg);
      }
    });
  }
};

// help logic
const helpVisible = ref(false);
const helpStep = ref(1);
const formHelpState = reactive({
  email: '',
});
const formHelpRef = ref(null);
const handleHelpSection = (type) => {
  if (type === 'email') {
    helpStep.value = 2;
  } else if (type === 'link') {
    generateHelpToken().then((res) => {
      if (res.code == 0) {
        handleCopyContact(res.data);
      } else {
        message.error(res.msg);
      }
    });
  }
};
const handleSubmitEmailHelp = () => {
  formHelpRef.value.validate().then(() => {
    isSubmitDisabled.value = true;
    isSendingHelp.value = true;
    sendResumeHelp({ email: formHelpState.email })
      .then((res) => {
        if (res.code == 0) {
          message.success(res.msg);
          formHelpState.email = '';
          helpStep.value = 1;
          helpVisible.value = false;
        } else {
          message.error(res.msg);
        }
      })
      .finally(() => {
        isSubmitDisabled.value = false;
        isSendingHelp.value = false;
      });
  });
};

// complete resume logic
const completeVisible = ref(false);
const formCompleteState = reactive({
  jobStatus: 'Part-time',
  city: '',
  jobSkills: [],
});
const completeState = reactive({
  jobStatus: 'Part-time',
  city: '',
  jobSkills: [],
});
const formCompleteRef = ref(null);
const handleCompleteResume = () => {
  formCompleteRef.value.validate().then(() => {
    updateResumeMajor({ ...toRaw(formCompleteState), resumeId: resumeId.value }).then((res) => {
      if (res.code == 0) {
        message.success(res.msg);
        completeVisible.value = false;
        getResumeInfo();
        getPositionList();
      } else {
        message.error(res.msg);
      }
    });
  });
};

const PositionCompleteModalRef = ref(null);
const handleOpenPositionModal = () => {
  PositionCompleteModalRef.value.open();
};
const handleCompleteSelectPositionItem = (positionItem, skillItem) => {
  const positionState = {
    jobCategoryId: positionItem.categoryId,
    jobCategoryName: positionItem.categoryName,
    level: positionItem.level,
    jobSkills: [],
  };
  formCompleteState.jobSkills[0] = positionState;

  if (!skillItem) {
    return;
  }

  for (const data of skillItem) {
    const skillState = {
      jobCategoryId: data.categoryId,
      jobCategoryName: data.categoryName,
      level: data.level,
    };
    formCompleteState.jobSkills[0].jobSkills.push(skillState);
  }
};

function maskMobile(mobile) {
  const mobileStr = String(mobile);
  const length = mobileStr.length;

  if (length <= 4) {
    return mobileStr.replace(/./g, '*');
  }

  const start = mobileStr.slice(0, Math.floor(length / 2) - 2);
  const end = mobileStr.slice(Math.ceil(length / 2) + 2);
  return start + '****' + end;
}

function maskEmail(email) {
  const [localPart, domain] = email.split('@');
  const maskedLocal = localPart.slice(0, 2) + '****' + localPart.slice(-2);
  return maskedLocal + '@' + domain;
}

const handleCopyContact = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(text)
      .then(() => message.success('Copy successful'))
      .catch(() => {
        message.error('Copy Failed');
      });
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      message.success('Copy successful');
    } catch (err) {
      message.error('Copy Failed');
    } finally {
      document.body.removeChild(textarea);
    }
  }
};

const suggestionsRef = ref(null);
const handleClickOutside = (event) => {
  if (suggestionsRef.value && !suggestionsRef.value.contains(event.target)) {
    showSuggestions.value = false;
  }
};

const isHelpEditResume = ref(false);
const isPageLoading = ref(true);

const initResumeInfo = () => {
  isPageLoading.value = true;
  return Promise.all([
    getResumeInfo(),
    getPositionList(),
    getWorkExperienceList(),
    getCategoryList(),
    getEducationListList(),
    getEvaluationList(),
    getEvaluationActiveList(),
    getResumeCert(),
  ]).finally(() => {
    isPageLoading.value = false;
  });
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  document.addEventListener('click', handleBusinessClickOutside);
  document.addEventListener('click', handleSchoolClickOutside);
  document.addEventListener('click', handleVideoActionClickOutside);
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token') || '';

  if (token) {
    loginSubmitByToken(token).then((res) => {
      if (res.code == 0) {
        store.dispatch('login', res.data.token);
        store.commit('setCurrentAccount', res.data);
        Cookies.set('token', res.data.token);
        isHelpEditResume.value = true;
        initResumeInfo();
      } else {
        message.error(res.msg);
        router.replace('index');
      }
    });
  } else {
    initResumeInfo();
  }
});
</script>

<style lang="less">
.resume_drawer {
  .ant-drawer-content-wrapper {
    width: 560px !important;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  }
  .ant-drawer-mask {
    transition: opacity 0.3s ease-out;
    background: rgba(0, 0, 0, 0.45);
  }
  .anticon {
    color: #6b7280;
    transition: color 0.2s ease;
    &:hover {
      color: #1a1a1a;
    }
  }
  .confirm_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    line-height: normal;
    display: block;
    flex: 1;
    padding: 12px 24px;
    height: auto;
    border: none;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(5, 100, 79, 0.25);
    &:hover {
      background: #047a5f;
      color: #fff;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(5, 100, 79, 0.35);
    }
    &:active {
      transform: translateY(0);
    }
  }
  .ant-drawer-header {
    border: none;
    padding: 24px 28px 16px;
    .ant-drawer-title {
      font-size: 20px;
      font-weight: 600;
      color: #1a1a1a;
    }
    .ant-drawer-close {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      transition: all 0.2s ease;
      &:hover {
        background: #f3f4f6;
      }
    }
  }
  .ant-drawer-body {
    padding: 0 28px 28px;
  }
  .resume_form {
    position: relative;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #1a1a1a;
      margin-bottom: 6px;
      letter-spacing: -0.2px;
    }
    .description {
      font-size: 13px;
      color: #6b7280;
      line-height: 1.5;
    }
    .avatar_wrapper {
      text-align: center;
      .avatar {
        margin: 24px auto 8px;
        width: fit-content;
        position: relative;
        img {
          width: 80px;
          height: 80px;
          cursor: pointer;
          border-radius: 50%;
          border: 1px solid rgba(5, 100, 79, 0.3);
          object-fit: cover;
        }
        .mask {
          display: none;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .upload_icon {
            width: 20px;
            height: 20px;
            border-radius: 0;
          }
        }
        .avatar_loading {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background: linear-gradient(0deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75));
        }
        &:hover {
          .mask {
            display: flex;
          }
        }
      }
      .update {
        color: #0256ff;
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 24px;
        cursor: pointer;
      }
    }
    .business_input {
      width: 100%;
      border: 1px solid rgba(5, 100, 79, 0.3) !important;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px 20px !important;
      font-size: 14px;
      color: #05644f;
      overflow: hidden;
      position: relative;
      z-index: 1;
    }
    .business_input .ant-select {
      width: 100%;
      border: none !important;
      box-shadow: none !important;
      position: relative;
      z-index: 0;
    }
    .business_input .ant-select .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      height: auto !important;
      min-height: 24px !important;
    }
    .business_input .ant-select .ant-select-selector:focus,
    .business_input .ant-select .ant-select-selector:hover,
    .business_input .ant-select-focused .ant-select-selector {
      border-color: transparent !important;
      box-shadow: none !important;
    }
    .business_input .ant-select .ant-select-selector .ant-select-selection-search-input {
      font-size: 14px;
      padding: 0 !important;
      height: auto;
      color: #05644f;
      width: 100%;
    }
    .business_input .ant-select .ant-select-selector .ant-select-selection-placeholder {
      color: rgba(5, 100, 79, 0.33);
      font-size: 14px;
      line-height: 24px;
      padding: 0 !important;
    }
    .business_input .ant-select-dropdown {
      border: 1px solid rgba(5, 100, 79, 0.3) !important;
      border-radius: 16px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
    }
    .business_input .ant-select-dropdown-menu-item {
      color: #05644f;
      font-size: 14px;
      padding: 10px 20px;
    }
    .business_input .ant-select-dropdown-menu-item:hover {
      background: rgba(5, 100, 79, 0.1) !important;
      color: #05644f !important;
    }
    .business_input .ant-select-selection-search {
      inset-inline-start: 0 !important;
      inset-inline-end: 0 !important;
    }
    .business_input .ant-select-selection-item {
      color: #05644f;
      font-size: 14px;
      padding: 0 !important;
    }
    .business_input.ant-select-focused .ant-select-selector,
    .business_input .ant-select-focused .ant-select-selector,
    .business_input.ant-select-open .ant-select-selector,
    .business_input .ant-select-open .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
    }
    .business_input .ant-select-single .ant-select-selector .ant-select-selection-item,
    .business_input .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
      line-height: 24px !important;
    }

    .ant-form-item-label > label {
      font-size: 13px;
      font-weight: 500;
      color: #374151;
      width: 100%;
      padding-bottom: 6px;
      white-space: nowrap;
    }
    .ant-form-item .ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
      display: none;
    }
    .flex_box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 0;
      .label {
        padding-bottom: 12px;
        font-size: 12px;
        font-weight: 500;
        color: #3d3d3d;
        width: 100%;
      }
      .ant-form-item-has-error {
        .custom_datepicker {
          border-color: #ff7875;
        }
      }
      .ant-form-item,
      .custom_datepicker {
        flex: 1;
        margin-right: 20px;
        margin-bottom: 24px;
        &:last-child {
          margin-right: 0;
        }
        .ant-input {
          padding: 10px 20px !important;
        }
      }
      .custom_datepicker {
        border: 1px solid rgba(5, 100, 79, 0.3);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
        border-radius: 16px;
        padding: 10px 20px;
        color: #05644f;
        margin-bottom: 0;
        width: 100%;
        height: 48px;
        .ant-picker-suffix .anticon,
        .ant-picker-input > input {
          color: #05644f;
          font-size: 14px;
          padding: 0;
          &::placeholder {
            color: rgba(5, 100, 79, 0.33);
          }
        }
        .ant-picker-active-bar {
          background-color: #05644f;
        }
        #form_item_endDate::placeholder {
          color: #05644f;
        }
        .ant-picker-clear {
          right: 40px;
          .anticon {
            color: #05644f;
          }
        }
        .ant-picker-input {
          height: 100%;
          input {
            height: 100%;
            padding: 0;
          }
        }
      }
      .switch_item {
        padding-top: 5px;
        .ant-switch.ant-switch-checked {
          background-color: #05644f;
        }
        .switch_tips {
          margin-left: 8px;
          color: rgba(61, 61, 61, 0.5);
          font-size: 12px;
        }
      }
    }
    .resume_select,
    .city_select {
      margin-right: 15px;
      min-width: 120px;
      margin-bottom: 0 !important;
      &:hover {
        .ant-select-arrow {
          color: #ffffff;
        }
      }
      .ant-select-selector {
        border: 1px solid rgba(5, 100, 79, 0.3) !important;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
        color: #05644f;
        border-radius: 16px;
        height: 48px;
        padding: 0 20px;
        font-size: 14px;
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
          font-size: 14px;
          color: #05644f;
          line-height: 48px !important;
        }
      }
      .ant-select-arrow {
        color: #05644f;
      }
    }
    /* 确保Type of work seeking和Expected Address下拉框的描边颜色 */
    .resume_form .resume_select .ant-select-selector,
    .resume_form .city_select .ant-select-selector {
      border: 1px solid rgba(5, 100, 79, 0.3) !important;
    }
    .tips {
      color: #888;
      font-size: 12px;
      font-weight: 300;
      white-space: nowrap;
      margin-left: 10px;
    }
    .add_position {
      border: 1px dashed rgba(5, 100, 79, 0.5);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      color: rgba(5, 100, 79, 0.3);
      border-radius: 8px;
      padding: 12px;
      margin: 30px auto;
      cursor: pointer;
      .add_icon {
        width: 16px;
        height: 16px;
        margin-right: 10px;
        vertical-align: text-bottom;
      }
    }
    .job_position {
      margin: 30px auto;
      .position {
        padding: 12px;
        color: #05644f;
        border-radius: 16px;
        border: 1px solid rgba(5, 100, 79, 0.5);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
        cursor: pointer;
        .update_icon {
          position: absolute;
          top: 3px;
          right: 0;
        }
        .skill_wrapper {
          .skill_item {
            margin-top: 8px;
            display: inline-block;
            border-radius: 100px;
            margin-right: 12px;
            padding: 5px 8px;
            font-size: 12px;
            background: rgba(247, 131, 53, 0.1);
            color: #f78335;
          }
        }
      }
      .label {
        font-size: 12px;
        font-weight: 500;
        color: #3d3d3d;
        margin-bottom: 12px;
        position: relative;
      }
      .action_wrapper {
        position: absolute;
        right: 0;
        top: 0;
        .action_icon {
          width: 16px;
          height: 16px;
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .video_action_wrapper {
      text-align: right;
      color: #05644f;
      font-size: 16px;
      font-weight: 500;
      margin: 24px 0;
      .add_btn {
        cursor: pointer;
        img {
          margin-right: 10px;
          vertical-align: text-bottom;
        }
      }
    }
    .ant-input,
    .ant-textarea,
    .resume_form .ant-form-item .ant-input {
      border: 1px solid rgba(5, 100, 79, 0.3) !important;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px 20px !important;
      font-size: 14px;
      color: #05644f;
    }
    .ant-textarea::placeholder,
    .ant-input::placeholder {
      color: rgba(5, 100, 79, 0.33);
    }
    .ai_textarea_wrapper {
      margin: 25px 0;
      .label {
        padding-bottom: 12px;
        font-size: 12px;
        font-weight: 500;
        color: #3d3d3d;
        width: 100%;
      }
      .resume_textarea textarea {
        padding: 20px 20px 80px 20px !important;
        border: 1px solid rgba(5, 100, 79, 0.3) !important;
      }
      .ai_btn {
        background: #f78335;
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        position: absolute;
        padding: 6px 25px;
        bottom: 20px;
        left: 20px;
        border-radius: 100px;
        cursor: pointer;
        border: none;
        &:disabled {
          cursor: not-allowed;
        }
        .icon {
          width: 18px;
          height: 18px;
          margin-right: 10px;
          vertical-align: text-bottom;
        }
      }
      .ant-input-textarea-show-count::after {
        color: #d1d1d1;
        white-space: nowrap;
        content: attr(data-count);
        pointer-events: none;
        float: right;
        position: absolute;
        bottom: 20px;
        right: 20px;
      }
    }
    .evaluation_tabs_wrapper {
      position: relative;
      .action_wrapper {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
        .action_icon {
          margin: 0 10px;
          cursor: pointer;
        }
        .action_switch {
          margin-left: 10px;
          &.ant-switch-checked {
            background-color: #05644f;
          }
        }
      }
    }
    .evaluation_list_wrapper {
      .evaluation_item {
        box-sizing: border-box;
        border: 1px solid rgba(149, 184, 159, 0.5);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        padding: 24px;
        font-size: 14px;
        color: #05644f;
        border-radius: 8px;
        margin-bottom: 12px;
        .evaluation_email {
          font-size: 16px;
          font-weight: bold;
        }
        .cancel_btn {
          color: #0256ff;
          float: right;
          cursor: pointer;
        }
      }
    }
  }
  .delete_icon {
    margin-right: 10px;
    cursor: pointer;
  }
}
.resume_select_dropdown {
  background: #fff;
  min-width: 200px !important;
  padding: 10px;
  .ant-select-item {
    color: #05644f;
    background: #fff;
    &:hover,
    &.ant-select-item-option-active,
    &.ant-select-item-option-selected {
      background: rgba(5, 100, 79, 0.1);
      color: #05644f;
    }
  }
}
.custom_datepicker_popup {
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    color: #fff;
    background: #05644f;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
    border: 1px solid #05644f;
  }
  .ant-picker-today-btn,
  .ant-picker-header-view button:hover {
    color: #05644f;
  }
}
.resume_modal {
  .ant-modal-content {
    border-radius: 20px;
  }
  .resume_detail {
    width: 100% !important;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 20px;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .resume_form .ant-input {
    border: 1px solid rgba(5, 100, 79, 0.3) !important;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03) !important;
    border-radius: 16px !important;
    padding: 10px 20px !important;
    font-size: 14px !important;
    color: #05644f !important;
  }
  .resume_form .ant-input::placeholder {
    color: rgba(5, 100, 79, 0.33) !important;
  }
}

.upload_wrapper {
  margin: 50px auto;
}
.note {
  color: #888;
  .title {
    font-size: 16px;
    font-weight: 700;
  }
  p {
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 2px;
    .dot {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #3d3d3d;
      margin-right: 8px;
      display: inline-block;
    }
  }
}
.submit_btn {
  background: #05644f;
  border-radius: 100px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
  display: block;
  width: 100%;
  padding: 0 20px;
  height: 48px;
  margin-top: 20px;
  cursor: pointer;
  box-shadow: none;
  border: none;
  &,
  &:hover,
  &:focus,
  &:focus-visible,
  &:active,
  &.ant-btn:hover,
  &.ant-btn-primary:hover {
    background: #05644f !important;
    color: #fff !important;
    box-shadow: none !important;
  }
  .btn_arrow {
    margin-left: 10px;
    font-size: 18px;
  }
  .btn_icon {
    width: 18px;
    height: 18px;
    margin-left: 10px;
  }
}
.modal_form {
  .form_label {
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .resume_select {
    margin-right: 15px;
    min-width: 120px;
    .ant-select-selector {
      border: 1px solid #05644f !important;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      color: #05644f;
      border-radius: 100px;
      box-shadow: none !important;
      .ant-select-selection-item {
        font-size: 14px;
        color: #05644f;
      }
      .ant-select-selection-placeholder {
        font-size: 14px;
      }
    }
    .ant-select-arrow {
      color: #05644f;
    }
  }
  .resume_complete_select {
    .ant-select-selector {
      border-radius: 16px;
    }
  }
}
.skill_container {
  padding-top: 20px;
  .skill_wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    gap: 10px;
    min-height: 100px;
    .skill {
      border-radius: 100px;
      padding: 5px 10px;
      border: 1px solid rgba(194, 94, 27, 0.5);
      color: #c25e1b;
      cursor: pointer;
      &.selected {
        background: #fef2ea;
        border-color: transparent;
      }
    }
  }
  .select_count {
    font-size: 12px;
    color: rgba(61, 61, 61, 0.5);
    margin-bottom: 10px;
  }
  .btn_wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
  }
  .confirm_btn,
  .cancel_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    display: block;
    flex: 1;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    border: none;
    &.cancel_btn {
      background: rgba(5, 100, 79, 0.3);
      color: #fff;
    }
  }
}
.ant-form-item-has-error .resume_position_wrapper {
  border-color: #ff7875;
}
.resume_position_wrapper {
  border: 1px solid rgba(5, 100, 79, 0.5);
  color: #05644f;
  border-radius: 16px;
  min-height: 38px;
  line-height: 38px;
  padding-left: 24px;
  font-size: 14px;
  cursor: pointer;
  .arrow_icon {
    width: 18px;
    height: 18px;
    top: 45px;
    right: 10px;
    position: absolute;
  }
  .skill_wrapper {
    line-height: normal;
    .skill_item {
      margin-bottom: 8px;
      display: inline-block;
      border-radius: 100px;
      margin-right: 12px;
      padding: 5px 8px;
      font-size: 12px;
      background: rgba(247, 131, 53, 0.1);
      color: #f78335;
    }
  }
}
.resume_preview_modal {
  .ant-modal-content {
    background: transparent;
    box-shadow: none;
    .ant-modal-close {
      top: 42px;
      right: 42px;
    }
  }
}
.evaluation_modal {
  .ant-modal-content {
    border-radius: 20px;
  }
  .ant-modal-title,
  .ant-modal-header {
    margin-bottom: 0;
  }
  .tips {
    color: #05644f;
    font-size: 16px;
    font-weight: 300;
  }
  .section_wrapper {
    margin: 30px 0;
    .section {
      border: 1px solid rgba(5, 100, 79, 0.3);
      border-radius: 16px;
      padding: 10px 60px 10px 20px;
      position: relative;
      margin: 25px auto;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      color: #05644f;
      .label_icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .arrow_icon {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 10px;
        top: calc(50% - 10px);
      }
      .label_description {
        margin-top: 10px;
        font-size: 12px;
        font-weight: 300;
      }
    }
  }
}
.suggestions_list {
  position: absolute;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  width: 100%;
  margin-top: 10px;
  z-index: 999;
  li {
    list-style: none;
    padding: 10px 20px;
    color: #05644f;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      background: rgba(5, 100, 79, 0.1);
    }
    .position {
      margin-left: 20px;
      color: rgba(5, 100, 79, 0.5);
    }
  }
}
.business_suggestions {
  border: 1px solid rgba(5, 100, 79, 0.3);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  li {
    font-size: 14px;
    .business_name {
      color: #05644f;
    }
  }
}
.school_suggestions {
  border: 1px solid rgba(5, 100, 79, 0.3);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  li {
    font-size: 14px;
    .school_name {
      color: #05644f;
    }
  }
}
.evaluation {
  margin-bottom: 15px;
  .label {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 16px;
    .name {
      font-weight: bold;
      color: #3d3d3d;
      margin-right: 24px;
    }
    .relation {
      font-weight: 300;
      color: rgba(61, 61, 61, 0.5);
    }
  }
  .content {
    position: relative;
    border: 1px solid rgba(149, 184, 159, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    padding: 32px;
    border-radius: 8px;
    line-height: 1.8;
    font-size: 15px;
    font-weight: 400;
    white-space: pre-wrap;
    color: #4a4a4a;
    letter-spacing: 0.1px;
    word-break: break-all;
    &::before {
      content: '';
      position: absolute;
      top: -10px;
      left: 20px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgba(149, 184, 159, 0.5);
    }
    &::after {
      content: '';
      position: absolute;
      top: -8px;
      left: 21px;
      width: 0;
      height: 0;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 9px solid #ffffff;
    }
    .file_wrapper {
      margin-top: 15px;
      .img_preview {
        max-width: 230px;
        height: auto;
        border-radius: 8px;
      }
      .video_player {
        width: 230px;
        height: auto;
        max-height: 130px;
        border-radius: 8px;
        background: #000;
        cursor: pointer;
        object-fit: cover;
        display: block;
      }
    }
  }
}
.user_center_modal {
  color: #05644f;
  font-size: 16px;
  .ant-modal-content {
    border-radius: 20px;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .modal_form {
    margin-top: 20px;

    .ant-input,
    .ant-input-password {
      border: 1px solid #05644f;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px 24px;
      font-size: 14px;
      color: #05644f;
    }
    .ant-input-password {
      padding: 0 10px 0 0;
      .ant-input {
        border: none;
      }
    }
    .ant-input-password-icon,
    .ant-input-password-icon:hover {
      color: #05644f;
      font-size: 18px;
    }
    .ant-input::placeholder {
      color: rgba(5, 100, 79, 0.33);
    }
    .business_input {
      width: 100%;
      border: 1px solid rgba(5, 100, 79, 0.3) !important;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px 20px !important;
      font-size: 14px;
      color: #05644f;
      overflow: hidden;
      position: relative;
      z-index: 1;
    }
    .business_input .ant-select {
      width: 100%;
      border: none !important;
      box-shadow: none !important;
      position: relative;
      z-index: 0;
    }
    .business_input .ant-select .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      height: auto !important;
      min-height: 24px !important;
    }
    .business_input .ant-select .ant-select-selector:focus,
    .business_input .ant-select .ant-select-selector:hover {
      border-color: transparent !important;
      box-shadow: none !important;
    }
    .business_input .ant-select .ant-select-selector .ant-select-selection-search-input {
      font-size: 14px;
      padding: 0 !important;
      height: auto;
      color: #05644f;
      width: 100%;
    }
    .business_input .ant-select .ant-select-selector .ant-select-selection-placeholder {
      color: rgba(5, 100, 79, 0.33);
      font-size: 14px;
      line-height: 24px;
      padding: 0 !important;
    }
    .business_input .ant-select-dropdown {
      border: 1px solid rgba(5, 100, 79, 0.3) !important;
      border-radius: 16px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
    }
    .business_input .ant-select-dropdown-menu-item {
      color: #05644f;
      font-size: 14px;
      padding: 10px 20px;
    }
    .business_input .ant-select-dropdown-menu-item:hover {
      background: rgba(5, 100, 79, 0.1) !important;
      color: #05644f !important;
    }
    .send_code_btn {
      position: absolute;
      right: 24px;
      top: 12px;
      color: #05644f;
      background: transparent;
      border: none;
      cursor: pointer;
      font-weight: 500;
      min-width: 30px;
    }
    .btn_wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;
      gap: 20px;
    }
    .confirm_btn,
    .cancel_btn {
      background: #05644f;
      border-radius: 100px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      line-height: normal;
      display: block;
      flex: 1;
      padding: 10px 20px;
      height: auto;
      margin-top: 20px;
      border: none;
      &.cancel_btn {
        background: rgba(5, 100, 79, 0.3);
        color: #fff;
      }
    }
    .replace_btn:disabled {
      background: rgba(0, 0, 0, 0.2);
    }
    .ai_loading {
      position: absolute;
      z-index: 999;
      top: 40px;
      left: calc(50% - 30px);
      .anticon-spin,
      .ant-spin-text {
        margin-top: 5px;
        color: #05644f !important;
      }
    }
  }
  .submit_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    display: block;
    width: 100%;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    box-shadow: none;
    border: none;
    &:hover {
      background: #05644f;
      color: #fff;
    }
    .btn_arrow {
      margin-left: 10px;
      font-size: 18px;
    }
  }
}
.ai_error_modal {
  text-align: center;
  .ant-modal-content {
    padding: 32px 20px;
  }
  .error_icon {
    width: 80px;
    height: 80px;
    display: block;
    margin: 20px auto;
  }
  .error_text {
    color: #3d3d3d;
    font-size: 16px;
    margin: 30px;
  }
  .confirm_btn {
    margin: 50px auto 0;
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    display: block;
    flex: 1;
    padding: 18px;
    height: auto;
    border: none;
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    &:hover {
      background: #05644f;
      color: #fff;
    }
  }
}
.tips_wrapper {
  position: relative;
  color: #f78335;
  padding-left: 30px;
  line-height: 18px;
  font-size: 12px;
  img {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 8px;
    left: 0;
  }
}

// Custom tooltip styles - global override
.ant-tooltip {
  .ant-tooltip-inner {
    background-color: rgba(0, 0, 0, 0.75) !important;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.5;
    animation: tooltipFadeIn 0.3s ease-out;
    color: #fff;
  }
  .ant-tooltip-arrow {
    display: none !important;
  }
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 手机端（≤640px）：编辑抽屉全屏，表单留白收紧，弹窗不溢出视口 */
@media (max-width: 640px) {
  .resume_drawer {
    .ant-drawer-content-wrapper {
      width: 100vw !important;
    }
    .ant-drawer-header {
      padding: 16px 16px 12px;
    }
    .ant-drawer-body {
      padding: 0 16px 16px;
    }
    .resume_form {
      .ant-input {
        padding: 10px 12px !important;
      }
      .flex_box {
        .ant-form-item {
          margin-right: 12px;
        }
        .ant-input {
          padding: 10px 12px !important;
        }
        .custom_datepicker {
          padding: 10px 12px;
        }
      }
    }
  }
  // antd 弹窗默认 520px / 预览弹窗 1100px，均会溢出手机视口
  .resume_modal,
  .user_center_modal {
    max-width: calc(100vw - 24px);
  }
  .ant-modal.resume_preview_modal {
    width: calc(100vw - 24px) !important;
    top: 24px !important;
    .ant-modal-content .ant-modal-close {
      top: 12px;
      right: 12px;
    }
  }
  .evaluation_modal .section_wrapper .section {
    padding: 10px 40px 10px 16px;
  }
}
</style>

<style scoped lang="less">
.container {
  position: relative;
  .back-link {
    position: fixed;
    top: 32px;
    left: 32px;
    z-index: 100;
  }
  .back_btn {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }
}
.resume_detail {
  background-color: white;
  border-radius: 20px;
  break-inside: avoid;
  height: fit-content;
  padding: 56px;
  transition: transform 0.3s;
  margin-bottom: 20px;
  position: relative;
  // 原本写死 850px，768~850px 的平板就会横向溢出；改为最大宽度，窄屏自动收缩
  width: min(850px, calc(100% - 48px));
  box-sizing: border-box;
  margin: 108px auto 80px;
  > .resume_title {
    color: #05644f;
    font-size: 28px;
    font-weight: 700;
    top: -48px;
    left: 0;
    position: absolute;
    letter-spacing: -0.3px;
  }
  .title {
    font-size: 20px;
    color: #1a1a1a;
    margin: 40px 0 20px;
    font-weight: 600;
    position: relative;
    letter-spacing: -0.2px;
  }
  .score_wrapper {
    background: #e5efed;
    padding: 24px;
    border-radius: 8px;
    color: #05644f;
    margin-bottom: 32px;
    position: relative;
    .label {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 12px;
      letter-spacing: -0.2px;
    }
    .tips {
      font-size: 14px;
      font-weight: 400;
      line-height: 1.6;
    }
    .score_btn_wrapper {
      position: absolute;
      right: 24px;
      top: 40px;
      .score_btn {
        border: 1px solid rgba(5, 100, 79, 0.5);
        padding: 8px 14px;
        border-radius: 100px;
        margin-left: 10px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        display: none;
        img {
          width: 8px;
          margin-left: 6px;
        }
        &:nth-child(1),
        &:nth-child(2) {
          display: inline;
        }
      }
    }
    .score_tips {
      font-size: 14px;
      opacity: 0.6;
      line-height: 1.5;
    }
  }
  .info_wrapper {
    display: flex;
    position: relative;
    .avatar {
      width: 112px;
      height: 112px;
      border-radius: 50%;
      margin-right: 0;
      position: absolute;
      right: 0px;
      cursor: pointer;
      object-fit: cover;
    }
    .info {
      .name {
        color: #1a1a1a;
        font-size: 32px;
        font-weight: 700;
        width: 100%;
        letter-spacing: -0.5px;
      }
      .type {
        color: #666666;
        margin: 16px auto 24px;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.2px;
        span {
          opacity: 0.4;
          margin: 0 8px;
        }
      }
      .contact {
        display: flex;
        align-items: center;
        color: #666666;
        .email,
        .phone,
        .ins {
          display: flex;
          align-items: center;
          font-size: 14px;
          margin-right: 24px;
          cursor: pointer;
          font-weight: 400;
          letter-spacing: 0.2px;
          img {
            width: 18px;
            height: 18px;
            margin-right: 8px;
          }
        }
      }
    }
  }
  .tag_wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 32px 0;
    gap: 10px;
    .tag {
      border-radius: 100px;
      padding: 8px 16px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.2px;
      &.tag_positon {
        background: rgba(5, 100, 79, 0.1);
        color: #05644f;
      }
      &.tag_skill {
        background: rgba(247, 131, 53, 0.1);
        color: #f78335;
      }
    }
  }
  .video_wrapper {
    margin-top: 15px;
    .title {
      .more {
        font-size: 16px;
        color: #05644f;
        float: right;
        margin-top: 10px;
      }
    }
  }
  .advantage_wrapper {
    .description {
      font-size: 15px;
      color: #4a4a4a;
      line-height: 1.8;
      white-space: pre-wrap;
      font-weight: 400;
      letter-spacing: 0.1px;
    }
  }
  .work_wrapper {
    .experience_wrapper {
      margin: 28px auto;
      .experience {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 12px;
        font-size: 16px;
        color: #1a1a1a;
        position: relative;
        .left_info {
          display: flex;
          flex-direction: column;
          gap: 6px;
          flex: 1;
        }
        .right_info {
          display: flex;
          align-items: center;
          gap: 12px;
          .time {
            color: #888;
            white-space: nowrap;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0.2px;
          }
          .edit_icon {
            width: 18px;
            height: 18px;
            cursor: pointer;
          }
        }
        .company {
          font-weight: 600;
          font-size: 17px;
          letter-spacing: -0.2px;
        }
        .position {
          font-weight: 500;
          font-size: 15px;
          color: #4a4a4a;
          letter-spacing: 0.1px;
        }
      }
      .content {
        line-height: 1.8;
        font-size: 15px;
        color: #4a4a4a;
        white-space: pre-wrap;
        font-weight: 400;
        letter-spacing: 0.1px;
      }
    }
  }
  .education_wrapper {
    .experience_wrapper {
      margin: 24px auto;
      .experience {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        font-size: 16px;
        color: #1a1a1a;
        gap: 12px;
        position: relative;
        .school_icon {
          width: 52px;
          height: 52px;
          margin-right: 12px;
        }
        .info {
          flex: 1;
          .school_row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            .right_info {
              display: flex;
              align-items: center;
              gap: 12px;
              .time {
                font-weight: 400;
                color: #888;
                white-space: nowrap;
                font-size: 14px;
                letter-spacing: 0.2px;
              }
              .edit_icon {
                width: 18px;
                height: 18px;
                cursor: pointer;
              }
            }
          }
          .school {
            font-weight: 600;
            font-size: 16px;
            margin-right: 24px;
            letter-spacing: -0.2px;
          }
          .degree,
          .major {
            font-weight: 500;
            font-size: 15px;
            color: #4a4a4a;
            margin-right: 20px;
            letter-spacing: 0.1px;
          }
        }
      }
      .content {
        line-height: 1.8;
        font-size: 15px;
        color: #4a4a4a;
        white-space: pre-wrap;
        font-weight: 400;
        letter-spacing: 0.1px;
      }
    }
  }
  .cert_wrapper {
    .description {
      font-size: 15px;
      font-weight: 400;
      color: #4a4a4a;
      margin-bottom: 20px;
      white-space: pre-wrap;
      line-height: 1.6;
      letter-spacing: 0.1px;
    }
    .cert_content {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 16px;
      height: auto;
      .cert {
        width: calc(33.33% - 11px);
        border-radius: 8px;
        position: relative;
        .cert_preview {
          height: 135.73px;
          cursor: pointer;
        }
      }
    }
  }
  .evaluation_wrapper {
    margin-bottom: 50px;
    .content {
      word-wrap: break-word;
      line-height: 24px;
      font-size: 14px;
      color: #888;
      white-space: pre-wrap;
    }
  }
  .influence_wrapper {
    margin-bottom: 50px;
    .description {
      font-size: 14px;
      font-weight: 300;
      color: #3d3d3d;
      white-space: pre-wrap;
    }
  }
  .edit_icon {
    margin-left: 12px;
    cursor: pointer;
  }
  .edit_icon_right {
    position: absolute;
    right: 0;
    top: 10px;
  }
  .add_wrapper {
    border: 1px dashed rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    text-align: left;
    padding: 16px;
    border-radius: 8px;
    cursor: pointer;
    margin: 48px auto;
    font-size: 14px;
    color: rgba(5, 100, 79, 0.5);
    .add_icon {
      width: 16px;
      height: 16px;
      margin-right: 15px;
    }
  }
  .resume_action_wrapper {
    position: absolute;
    right: -120px;
    top: 50%;
    background: #b8dfc8;
    box-sizing: border-box;
    border: 1px solid rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 100px;
    padding: 15px;
    color: #05644f;
    .item {
      text-align: center;
      cursor: pointer;
      border-top: 1px solid rgba(5, 100, 79, 0.25);
      padding: 10px 0;
      &:first-child {
        border-top: none;
      }
      p {
        margin: 10px 0;
      }
    }
  }
}
// 仅桌面（抽屉 560px 有足够空间）才把卡片左移；≤1080 时不位移，避免卡片被推出屏幕
@media (min-width: 1081px) {
  .edit_resume_detail {
    margin-right: calc(378px + ((100% - 378px) / 2 - 325px));
  }
}
.video_content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 24px;
  // 排序时 TransitionGroup 自动做 FLIP，换行重排也能平滑滑动
  .video-move {
    transition: transform 0.3s cubic-bezier(0.22, 0.61, 0.36, 1);
  }
  .video {
    width: calc(33.33% - 16px);
    position: relative;
    .video_title {
      font-size: 14px;
      color: #333333;
      margin-top: 12px;
      margin-bottom: 0;
      word-break: break-word;
      width: 100%;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 20px;
    }
    .video_player {
      border-radius: 8px;
      height: 429px;
      width: 100%;
      cursor: pointer;
      background: #000;
      object-fit: cover;
      display: block;
    }
    .video_duration {
      color: #ffffff;
      font-size: 12px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      position: absolute;
      top: 390px;
      right: 15px;
      padding: 2px 5px;
    }
    .mask {
      display: none;
    }
    // 三点按钮仅触屏显示，桌面继续用 hover
    .video_more_btn {
      display: none;
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 100;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.55);
      align-items: center;
      justify-content: center;
      gap: 3px;
      cursor: pointer;
      span {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #ffffff;
      }
    }
    .video_content_action_wrapper {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 99;
      width: 100%;
      height: 100%;
      flex-wrap: wrap;
      align-content: flex-start;
      padding-top: 36px;
      .video_content_action {
        margin: 12px auto;
        display: flex;
        justify-content: center;
        gap: 24px;
        width: 60%;
        margin-bottom: 32px;
        .action_icon {
          width: 18px;
          height: 18px;
          margin: 0 10px;
          cursor: pointer;
          transition: transform 0.15s ease;
          // 点击时轻微缩放，给排序操作即时反馈
          &:active {
            transform: scale(0.88);
          }
          &.action_disabled {
            opacity: 0.5;
            cursor: default;
          }
        }
        &:first-child {
          .action_icon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
    &:hover {
      .mask {
        display: block;
      }
      .video_content_action_wrapper {
        display: flex;
      }
    }
    &.sort_clicked {
      .mask,
      .video_content_action_wrapper {
        display: none !important;
      }
    }
  }
}
.cert_content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 10px;
  .cert {
    width: calc(33.33% - 6.66px);
    border-radius: 8px;
    position: relative;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    aspect-ratio: 16 / 9;
    .cert_preview {
      width: 100%;
      border-radius: 0;
      height: 100%;
      object-fit: contain;
      &.cert_preview_landscape {
        object-fit: cover;
      }
      &.cert_preview_portrait {
        object-fit: contain;
      }
    }
    .mask {
      display: none;
      cursor: pointer;
      height: 100%;
      bottom: 0;
      top: 0;
      border-radius: 8px;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6));
    }
    .cert_content_action_wrapper {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 99;
      width: 100%;
      height: 100%;
      .cert_content_action {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
        .action_icon {
          width: 20px;
          height: 20px;
          cursor: pointer;
          &.action_disabled {
            opacity: 0.5;
            cursor: default;
          }
        }
      }
    }
    &:hover {
      .mask {
        display: block;
      }
      .cert_content_action_wrapper {
        display: block;
      }
    }
  }
  .add_cert {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    aspect-ratio: 16 / 9;
    background: transparent;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.add_video {
  width: 112px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed rgba(5, 100, 79, 0.5);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  cursor: pointer;
  margin: 48px 0;
  img {
    width: 20px;
    height: 20px;
  }
  .text {
    margin-top: 8px;
    color: rgba(5, 100, 79, 0.5);
    font-size: 12px;
    width: 100%;
    text-align: center;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75));
  border-radius: 10px;
}

.upload_cert {
  width: 200px !important;
  height: 112.5px !important;
  margin: 0 auto;
}

/* ≤1080：Preview/Help 胶囊原本 absolute right:-120px，会撑出视口，改为右下角悬浮 */
@media (max-width: 1080px) {
  .resume_action_wrapper {
    position: fixed;
    right: 16px;
    top: auto;
    bottom: 24px;
    z-index: 90;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    .item {
      border-top: none;
      padding: 0 6px;
      p {
        margin: 4px 0 0;
        font-size: 12px;
      }
    }
  }
}

/* ---------------- 手机端主卡片适配（≤640px） ---------------- */
@media (max-width: 640px) {
  .container .back-link {
    top: 12px;
    left: 12px;
  }

  .resume_detail {
    width: auto;
    margin: 64px 12px 32px;
    padding: 20px 16px;
    border-radius: 16px;

    > .resume_title {
      position: static;
      margin-bottom: 20px;
      font-size: 20px;
    }

    .title {
      font-size: 18px;
      margin: 28px 0 14px;
    }

    .score_wrapper {
      padding: 16px;
      margin-bottom: 24px;
      .label {
        font-size: 17px;
        margin-bottom: 8px;
      }
      .score_tips {
        font-size: 13px;
      }
      .score_btn_wrapper {
        position: static;
        margin-top: 12px;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        .score_btn {
          margin-left: 0;
          padding: 6px 12px;
          font-size: 13px;
        }
      }
    }

    .info_wrapper {
      .avatar {
        width: 64px;
        height: 64px;
      }
      .info {
        min-width: 0;
        padding-right: 76px;
        .name {
          font-size: 24px;
          letter-spacing: -0.3px;
          word-break: break-word;
        }
        .type {
          font-size: 14px;
          margin: 10px 0 14px;
        }
        .contact {
          flex-wrap: wrap;
          row-gap: 6px;
          .email,
          .phone,
          .ins {
            font-size: 13px;
            margin-right: 16px;
            img {
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }
          }
        }
      }
    }

    .tag_wrapper {
      margin: 20px 0;
      gap: 8px;
      .tag {
        padding: 6px 12px;
      }
    }

    .work_wrapper {
      .experience_wrapper {
        margin: 18px auto;
        .experience {
          font-size: 14px;
          .company {
            font-size: 16px;
          }
          .position {
            font-size: 14px;
          }
          .right_info .time {
            font-size: 13px;
          }
        }
        .content {
          font-size: 14px;
        }
      }
    }

    .education_wrapper {
      .experience_wrapper {
        margin: 18px auto;
        .experience {
          gap: 10px;
          font-size: 14px;
          .school_icon {
            width: 40px;
            height: 40px;
            margin-right: 0;
          }
          .info {
            .school_row {
              flex-wrap: wrap;
              row-gap: 4px;
            }
            .school {
              font-size: 15px;
              margin-right: 12px;
            }
            .degree,
            .major {
              font-size: 14px;
              margin-right: 12px;
            }
            .right_info .time {
              font-size: 13px;
            }
          }
        }
        .content {
          font-size: 14px;
        }
      }
    }

    .advantage_wrapper .description {
      font-size: 14px;
      line-height: 1.7;
    }
    .evaluation_wrapper,
    .influence_wrapper {
      margin-bottom: 28px;
    }
    .influence_wrapper .description {
      font-size: 14px;
    }

    .add_wrapper {
      margin: 24px auto;
    }
    .add_video {
      width: 100%;
      height: 120px;
      margin: 24px 0;
    }

    // 卡片内证书是四层选择器，优先级高于下方 .cert_content .cert，需单独覆盖
    .cert_wrapper .cert_content .cert {
      width: calc(50% - 5px);
      .cert_preview {
        width: 100%;
        height: auto;
      }
    }
  }

  // 技能视频：桌面三列 + 429px 高会把画面拉成细长条，窄屏改两列并降高
  .video_content {
    gap: 12px;
    .video {
      width: calc(50% - 6px);
      .video_player {
        height: 190px !important;
      }
      .video_duration {
        top: 150px;
        right: 8px;
      }
      .video_title {
        font-size: 13px;
        line-height: 18px;
        margin-top: 8px;
      }
      // mask/操作层有内联 307px 高度，需与 190px 视频对齐
      .mask {
        height: 190px !important;
      }
      .video_content_action_wrapper {
        height: 190px !important;
        padding-top: 0;
        align-content: center;
        .video_content_action {
          margin: 8px auto;
        }
      }
    }
  }

  .cert_content {
    gap: 10px;
    .cert {
      width: calc(50% - 5px);
      .cert_preview {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .evaluation {
    .content {
      padding: 16px;
      font-size: 14px;
    }
    .content .file_wrapper {
      .img_preview {
        max-width: 100%;
      }
      .video_player {
        width: 100%;
        max-height: none;
      }
    }
  }
}

/* 触屏设备没有 hover：视频操作默认收起，点右上角三点后与网页版一样盖在视频上 */
@media (hover: none) {
  .video_content .video {
    .video_more_btn {
      display: flex;
    }
    .mask {
      display: none;
    }
    .video_content_action_wrapper {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      // 触屏改为两行垂直居中，两行之间拉开距离
      align-content: center;
      padding-top: 0;
      row-gap: 26px;
      .video_content_action {
        width: auto;
        margin: 0;
        gap: 0;
        flex: 1 1 50%;
        justify-content: space-around;
        .action_icon {
          margin: 0;
        }
        &:first-child .action_icon {
          width: 16px;
          height: 16px;
        }
        // 第二行是 2 个图标 + 1 个图标，按 2:1 分配宽度实现三等分间距
        &:nth-child(3) {
          flex: 2 1 66.66%;
        }
        &:nth-child(4) {
          flex: 1 1 33.33%;
        }
      }
    }
    // 触屏点击视频容易留下 sticky hover，这里必须压住桌面的 hover 规则
    &:hover {
      .mask {
        display: none;
      }
      .video_content_action_wrapper {
        display: none;
      }
    }
    &.action_open {
      .mask {
        display: block !important;
      }
      .video_content_action_wrapper {
        display: flex !important;
      }
      // 展开时隐藏三点图标，避免与功能按钮同时出现
      .video_more_btn {
        display: none;
      }
    }
  }

  .cert_content .cert {
    .mask {
      display: none;
    }
    .cert_content_action_wrapper {
      display: block;
      top: auto;
      bottom: 0;
      height: auto;
      background: rgba(0, 0, 0, 0.6);
      .cert_content_action {
        position: static;
        transform: none;
        display: flex;
        justify-content: center;
        padding: 6px 0;
        gap: 16px;
      }
    }
  }
}
</style>
